
import { forAll as forAll_1, toArray as toArray_1, add, ofArray as ofArray_1, tryFind, ofList, map as map_1, toList as toList_1, fold, FSharpMap__get_Item } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Constants_maxSettlingRounds, Constants_settlingTolerance, Constants_clearanceCostWeight, Constants_overlapCostWeight, Constants_clearanceFromSymbol, Constants_maxCornerSize, WireCorner, Constants_extensionTolerance, Extension, LineInfo, Constants_minWireSeparation, Constants_overlapTolerance, tryFindIndexInArray, moveLine, LocSearchDir, LineId__get_Index, hasOverlap, Constants_maxSegmentSeparation, Cluster, Constants_minWireLengthToSeparate, Constants_minVisibleSegmentLength, Constants_sameNetTrunkCapture, boundUnion, Constants_separateCaptureOverlap, hasNearOverlap, Constants_smallOffset, Line as Line_1, Bound as Bound_2 } from "./BusWireRoutingHelpers.js";
import { minBy, allPairs, choose, forAll, tail, sortBy as sortBy_1, tryFind as tryFind_1, sumBy, concat, getSlice, updateAt, removeManyAt, tryPick, exists, iterateIndexed, iterate, reduce, head, sortDescending, min, singleton, maxBy, max, isEmpty as isEmpty_1, reverse, filter, fold as fold_1, item as item_1, length as length_1, contains, mapIndexed, cons, append, toArray, collect, ofArray, map, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { stringHash, arrayHash, equalArrays, numberHash, comparePrimitives, compare, sign, compareArrays, uncurry2, safeHash, equals, disposeSafe, getEnumerator } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { empty as empty_1, singleton as singleton_1, collect as collect_2, delay, filter as filter_1, iterate as iterate_1, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { sortInPlaceBy, fold as fold_3, append as append_1, collect as collect_1, setItem, tryFindIndex, initialize, sortBy, mapIndexed as mapIndexed_1, item } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { List_distinct, List_except, List_groupBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { overlap1D, getAbsSegments, getFilteredAbsSegments } from "./BlockHelpers.js";
import { BoundingBox, XYPos } from "../Common/CommonTypes.js";
import { connToInt } from "../Common/Ids.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { DrawModelType_BusWireT_segments_, DrawModelType_SymbolT_DirectedPortId, DrawModelType_BusWireT_wireOf_, DrawModelType_BusWireT_Model, DrawModelType_BusWireT_Wire, DrawModelType_BusWireT_Segment, DrawModelType_BusWireT_wires_, DrawModelType_SymbolT_Annotation } from "../Model/DrawModelType.js";
import { printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { remove, FSharpSet__Contains, FSharpSet__get_Count, intersect, toList as toList_2, isEmpty, ofList as ofList_1, union, fold as fold_2 } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { dbg, warnOnce } from "../Shared/Log.js";
import { max as max_1, min as min_1 } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { filterWiresByCompMoved, isManuallyRouted, updateWireSegmentJumps, getAbsoluteSegmentPos } from "./BusWireUpdateHelpers.js";
import { MapModule_KeysL, MapModule_ValuesL } from "../Common/EEExtensions.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { list_type, option_type, tuple_type, record_type, float64_type, int32_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { getPortLocation } from "./Symbol.js";
import { updateWire, rerouteMovedWires, smartAutoroute } from "./BusWireRoute.js";

/**
 * return wire and segment index of line, if line a segment, otehrwise return None.
 */
export function lineToWire(model, line) {
    const matchValue = line.Seg1;
    if (matchValue == null) {
        return undefined;
    }
    else {
        let patternInput;
        const this$ = matchValue.Segment;
        patternInput = [this$.Index, this$.WireId];
        return [FSharpMap__get_Item(model.Wires, patternInput[1]), patternInput[0]];
    }
}

/**
 * Convert a segment into a fixed or movable line (of given orientation).
 * seg: ASegment of given segment to convert.
 * wire: wire of given segment to convert.
 * ori: orientation of segment (for reasons of efficiecny - it could be calculated from seg).
 * lType: type of line generated.
 */
export function segmentToLine(lType, ori, wire, seg) {
    const order = (a, b) => {
        if (a < b) {
            return new Bound_2(a, b);
        }
        else {
            return new Bound_2(b, a);
        }
    };
    const line = new Line_1(seg.Start.Y, order(seg.Start.X, seg.End.X), ori, seg, lType, empty(), wire.WId, wire.OutputPort, 0);
    if (ori === "vertical") {
        return new Line_1(seg.Start.X, order(seg.Start.Y, seg.End.Y), line.Orientation, line.Seg1, line.LType, line.SameNetLink, line.Wid, line.PortId, line.Lid);
    }
    else {
        return line;
    }
}

/**
 * Convert a symbol BoundingBox into two fixed lines (of given orientation).
 * The lines correspond to the two box edges of the specified orientation.
 */
export function bBoxToLines(ori, box) {
    const tl = box.TopLeft;
    return map((tupledArg) => (new Line_1(tupledArg[0], new Bound_2(tupledArg[1] + Constants_smallOffset, tupledArg[2] - Constants_smallOffset), ori, undefined, tupledArg[3], empty(), 0, 0, 0)), (ori === "vertical") ? ofArray([[tl.X, tl.Y, tl.Y + box.H, "bARRIERNEG"], [tl.X + box.W, tl.Y, tl.Y + box.H, "bARRIERPOS"]]) : ofArray([[tl.Y, tl.X, tl.X + box.W, "bARRIERNEG"], [tl.Y + box.H, tl.X, tl.X + box.W, "bARRIERPOS"]]));
}

/**
 * Where two segments in lines are on the same Net and on top of each other we must NEVER separate them.
 * This function links such segments, and marks all except the head one as a LINKEDSEG
 * so that the clustering algorithm will ignore them.
 * sameNetCapture specified how close segments muts be to be linked.
 */
export function linkSameNetLines(sameNetCapture, lines) {
    return collect((tupledArg) => {
        const lines_2 = toArray(tupledArg[1]);
        const enumerator = getEnumerator(toList(rangeDouble(0, 1, lines_2.length - 1)));
        try {
            while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                const a_3 = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
                const enumerator_1 = getEnumerator(toList(rangeDouble(0, 1, lines_2.length - 1)));
                try {
                    while (enumerator_1["System.Collections.IEnumerator.MoveNext"]()) {
                        let a_2, b_4;
                        const a = a_3 | 0;
                        const b_2 = enumerator_1["System.Collections.Generic.IEnumerator`1.get_Current"]() | 0;
                        const matchValue = item(a, lines_2);
                        const lb_1 = item(b_2, lines_2);
                        const la_1 = matchValue;
                        let linkableFollower;
                        if (lb_1.LType === "nORMSEG") {
                            linkableFollower = true;
                        }
                        else if ((lb_1.LType === "fIXEDSEG") && (la_1.LType === "fIXEDSEG")) {
                            const a_1 = la_1.P;
                            const b_3 = lb_1.P;
                            linkableFollower = (Math.abs(a_1 - b_3) < 0.001);
                        }
                        else {
                            linkableFollower = false;
                        }
                        if ((((((((la_1.LType === "nORMSEG") ? true : (la_1.LType === "fIXEDMANUALSEG")) ? true : (la_1.LType === "fIXEDSEG")) && linkableFollower) && (lb_1.LType !== "lINKEDSEG")) && !equals(la_1.Wid, lb_1.Wid)) && ((a_2 = la_1.P, (b_4 = lb_1.P, Math.abs(a_2 - b_4) < sameNetCapture)))) && hasNearOverlap(Constants_separateCaptureOverlap, la_1.B, lb_1.B)) {
                            item(b_2, lines_2).LType = "lINKEDSEG";
                            item(a, lines_2).B = boundUnion(la_1.B, lb_1.B);
                            item(a, lines_2).SameNetLink = append(cons(item(b_2, lines_2), item(b_2, lines_2).SameNetLink), item(a, lines_2).SameNetLink);
                            item(b_2, lines_2).SameNetLink = empty();
                        }
                    }
                }
                finally {
                    disposeSafe(enumerator_1);
                }
            }
        }
        finally {
            disposeSafe(enumerator);
        }
        return ofArray(lines_2);
    }, List_groupBy((line) => line.PortId, lines, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }));
}

/**
 * Make all lines, fixed and movable, of given orientation from wires and symbols in Model
 * ori - orientation of Lines (P coord is reverse of this)
 */
export function makeLines(wiresToRoute, ori, model) {
    const segLines = linkSameNetLines(Constants_sameNetTrunkCapture, mapIndexed((i, line) => {
        line.Lid = i;
        return line;
    }, fold((lines, _arg_3, wire_3) => {
        let wire;
        const wireIsRoutable = contains(wire_3.WId, wiresToRoute, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        });
        return append(map((aSeg) => {
            let matchValue_1, matchValue_2, this$_1, this$_2, this$_3;
            const segs = wire_3.Segments;
            const seg_2 = aSeg.Segment;
            return segmentToLine((matchValue_1 = (seg_2.Index === 2), (matchValue_2 = (seg_2.Index === (length_1(segs) - 3)), (seg_2.Mode === "manual") ? "fIXEDMANUALSEG" : (wireIsRoutable ? (matchValue_1 ? (((this$_1 = item_1(1, segs), Math.abs(this$_1.Length) < 1E-07)) ? "fIXEDSEG" : (matchValue_2 ? (((this$_2 = item_1(length_1(segs) - 2, segs), Math.abs(this$_2.Length) < 1E-07)) ? "fIXEDSEG" : "nORMSEG") : "nORMSEG")) : (matchValue_2 ? (((this$_3 = item_1(length_1(segs) - 2, segs), Math.abs(this$_3.Length) < 1E-07)) ? "fIXEDSEG" : "nORMSEG") : "nORMSEG")) : "fIXEDMANUALSEG"))), ori, wire_3, aSeg);
        }, getFilteredAbsSegments(uncurry2((wire = wire_3, (orient) => ((seg) => {
            const numSegs = length_1(wire.Segments) | 0;
            let wireLength;
            let vec;
            const left = wire.StartPos;
            let right;
            const this$ = wire;
            const wire_2 = this$;
            right = fold_1((tupledArg, seg_1) => {
                const currOrientation = tupledArg[2];
                let nextPos;
                const position = tupledArg[1];
                const length = seg_1.Length;
                nextPos = ((currOrientation === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)));
                return [nextPos, nextPos, (currOrientation === "vertical") ? "horizontal" : "vertical"];
            }, [this$.StartPos, wire_2.StartPos, wire_2.InitialOrientation], wire_2.Segments)[0];
            vec = (new XYPos(left.X - right.X, left.Y - right.Y));
            wireLength = Math.sqrt(Math.pow(vec.X, 2) + Math.pow(vec.Y, 2));
            return ((((ori === orient) && (seg.Index !== 0)) && (seg.Index !== (numSegs - 1))) && (Math.abs(seg.Length) > Constants_minVisibleSegmentLength)) && (wireLength > Constants_minWireLengthToSeparate);
        }))), wire_3)), lines);
    }, empty(), model.Wires)));
    return mapIndexed_1((i_1, line_2) => {
        line_2.Lid = i_1;
        return line_2;
    }, sortBy((line_1) => [line_1.P, line_1.B.MinB, line_1.B.MaxB, connToInt(line_1.Wid)], toArray(append(collect((tupledArg_2) => {
        let sym_1, patternInput, sym_2, comp, matchValue_4, vS, hS, matchValue_2_1, left_1, right_1;
        const sym = tupledArg_2[1];
        if (equals(sym.Annotation, undefined)) {
            return bBoxToLines(ori, (sym_1 = sym, (patternInput = ((sym_2 = sym_1, (comp = sym_2.Component, (matchValue_4 = defaultArg(sym_2.HScale, 1), (vS = defaultArg(sym_2.VScale, 1), (hS = matchValue_4, (matchValue_2_1 = sym_2.STransform.Rotation, (matchValue_2_1.tag === 2) ? [comp.H * vS, comp.W * hS] : ((matchValue_2_1.tag === 1) ? [comp.W * hS, comp.H * vS] : ((matchValue_2_1.tag === 3) ? [comp.W * hS, comp.H * vS] : [comp.H * vS, comp.W * hS]))))))))), equals(sym_1.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton) ? (new BoundingBox((left_1 = sym_1.Pos, (right_1 = (new XYPos(9, 9)), new XYPos(left_1.X - right_1.X, left_1.Y - right_1.Y))), 17, 17)) : (new BoundingBox(sym_1.Pos, patternInput[1], patternInput[0])))));
        }
        else {
            return empty();
        }
    }, toList_1(model.Symbol.Symbols)), segLines)), {
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    }));
}

function turnFrom(wSegs, index, step) {
    const walk = (i_mut) => {
        walk:
        while (true) {
            const i = i_mut;
            if ((i < 0) ? true : (i >= length_1(wSegs))) {
                return 0;
            }
            else if (Math.abs(item_1(i, wSegs).Length) > Constants_minVisibleSegmentLength) {
                return item_1(i, wSegs).Length;
            }
            else {
                i_mut = (i + step);
                continue walk;
            }
            break;
        }
    };
    return walk(index);
}

export function turnDirs(line, wires) {
    const matchValue = line.Seg1;
    if (matchValue != null) {
        const seg = matchValue.Segment;
        const wSegs = FSharpMap__get_Item(wires, seg.WireId).Segments;
        const patternInput = (seg.Length > 0) ? [turnFrom(wSegs, seg.Index + 1, 2), -turnFrom(wSegs, seg.Index - 1, -2)] : [-turnFrom(wSegs, seg.Index - 1, -2), turnFrom(wSegs, seg.Index + 1, 2)];
        return [sign(patternInput[0]), sign(patternInput[1])];
    }
    else {
        return toFail(printf("What? Expected Some segment - not None"));
    }
}

/**
 * How far the wire turns away at each end of a line segment, as absolute lengths.
 * Pair returned is MaxB, MinB end of line, matching turnDirs. Where two lines' ends coincide,
 * this is what says which wire encloses the other - the sign alone cannot.
 */
export function turnLengths(line, wires) {
    const matchValue = line.Seg1;
    if (matchValue != null) {
        const seg = matchValue.Segment;
        const wSegs = FSharpMap__get_Item(wires, seg.WireId).Segments;
        if (seg.Length > 0) {
            return [Math.abs(turnFrom(wSegs, seg.Index + 1, 2)), Math.abs(turnFrom(wSegs, seg.Index - 1, -2))];
        }
        else {
            return [Math.abs(turnFrom(wSegs, seg.Index - 1, -2)), Math.abs(turnFrom(wSegs, seg.Index + 1, 2))];
        }
    }
    else {
        return toFail(printf("What? Expected Some segment - not None"));
    }
}

/**
 * +1 if line1.P > line2.P for zero crossings.
 * -1 if line1.P < line2.P for zero crossings.
 * 0 if line1.P and line2.P have one crossing.
 */
export function numCrossingsSign(model, line1, line2, wires) {
    const matchValue = turnDirs(line1, wires);
    const matchValue_1 = turnDirs(line2, wires);
    const matchValue_2 = turnLengths(line1, wires);
    const matchValue_3 = turnLengths(line2, wires);
    const endSegOpt = (line) => {
        let index;
        const matchValue_4 = lineToWire(model, line);
        let matchResult, index_1, segs_1;
        if (matchValue_4 != null) {
            if ((index = (matchValue_4[1] | 0), (length_1(matchValue_4[0].Segments) === 9) && ((index === 3) ? true : (index === 5)))) {
                matchResult = 0;
                index_1 = matchValue_4[1];
                segs_1 = matchValue_4[0].Segments;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return item_1(index_1, segs_1);
            default:
                return undefined;
        }
    };
    let patternInput_2;
    const matchValue_5 = endSegOpt(line1);
    const matchValue_6 = endSegOpt(line2);
    let matchResult_1, seg;
    if (matchValue_5 == null) {
        if (matchValue_6 == null) {
            matchResult_1 = 1;
        }
        else {
            matchResult_1 = 0;
            seg = matchValue_6;
        }
    }
    else {
        matchResult_1 = 0;
        seg = matchValue_5;
    }
    switch (matchResult_1) {
        case 0: {
            patternInput_2 = (((seg.Length > 0) && (seg.Index === 3)) ? [1, 0] : [0, 1]);
            break;
        }
        default:
            patternInput_2 = [1, 1];
    }
    const atEnd = (tied, line1Inner, tupledArg, tupledArg_1) => {
        const turn1 = tupledArg[0] | 0;
        const len1 = tupledArg[1];
        const turn2 = tupledArg_1[0] | 0;
        const len2 = tupledArg_1[1];
        if (tied) {
            if (turn1 !== turn2) {
                return 0;
            }
            else if (compare(len1, len2) < 0) {
                return turn1 | 0;
            }
            else if (compare(len2, len1) < 0) {
                return op_UnaryNegation_Int32(turn2) | 0;
            }
            else {
                return 0;
            }
        }
        else if (line1Inner) {
            return turn1 | 0;
        }
        else {
            return op_UnaryNegation_Int32(turn2) | 0;
        }
    };
    const sameEnd = (a, b) => (Math.abs(a - b) < 1E-07);
    return ((patternInput_2[0] * atEnd(sameEnd(line1.B.MinB, line2.B.MinB), line1.B.MinB > line2.B.MinB, [matchValue[1], matchValue_2[1]], [matchValue_1[1], matchValue_3[1]])) + (patternInput_2[1] * atEnd(sameEnd(line1.B.MaxB, line2.B.MaxB), line1.B.MaxB < line2.B.MaxB, [matchValue[0], matchValue_2[0]], [matchValue_1[0], matchValue_3[0]]))) | 0;
}

/**
 * segL is a list of lines array indexes representing segments found close together.
 * Return the list ordered in such a way that wire crossings are minimised if the
 * segments are placed as ordered. The return list is placed with required P value increasing
 * along the list.
 */
export function orderPairwiseToMinimiseCrossings(model, lines, segL) {
    const numCrossingsSign$0027 = (l0, l1) => (numCrossingsSign(model, l0, l1, model.Wires) | 0);
    const matchValue = length_1(segL) | 0;
    switch (matchValue) {
        case 1:
            return segL;
        case 2:
            if (numCrossingsSign$0027(item(item_1(0, segL), lines), item(item_1(1, segL), lines)) > 0) {
                return ofArray([item_1(1, segL), item_1(0, segL)]);
            }
            else {
                return segL;
            }
        default: {
            const complete = (order_mut) => {
                complete:
                while (true) {
                    const order = order_mut;
                    const joined = map_1((_arg, afters) => fold_2((acc, b_1) => union(acc, FSharpMap__get_Item(order, b_1)), afters, afters), order);
                    if (joined.Equals(order)) {
                        return order;
                    }
                    else {
                        order_mut = joined;
                        continue complete;
                    }
                    break;
                }
            };
            const order_1 = complete(ofList(map((a) => [a, ofList_1(filter((b) => {
                if (b !== a) {
                    return numCrossingsSign$0027(item(a, lines), item(b, lines)) < 0;
                }
                else {
                    return false;
                }
            }, segL), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            })], segL), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            }));
            const place = (remaining_1_mut, placed_mut) => {
                place:
                while (true) {
                    const remaining_1 = remaining_1_mut, placed = placed_mut;
                    if (isEmpty(remaining_1)) {
                        return reverse(placed);
                    }
                    else {
                        let lengths_2;
                        const remaining = remaining_1;
                        lengths_2 = fold_1((lengths_1, _arg_2) => {
                            const lengths = lengths_1;
                            return map_1((seg, _arg_1) => {
                                const matchValue_3 = toList_2(intersect(FSharpMap__get_Item(order_1, seg), remaining));
                                if (isEmpty_1(matchValue_3)) {
                                    return 1;
                                }
                                else {
                                    return (1 + max(map((a_1) => (FSharpMap__get_Item(lengths, a_1) | 0), matchValue_3), {
                                        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                                    })) | 0;
                                }
                            }, lengths);
                        }, ofList(map((seg_1) => [seg_1, 1], toList_2(remaining)), {
                            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
                        }), toList(rangeDouble(1, 1, FSharpSet__get_Count(remaining))));
                        const next = maxBy((seg_2) => (FSharpMap__get_Item(lengths_2, seg_2) | 0), filter((value) => FSharpSet__Contains(remaining_1, value), segL), {
                            Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
                        }) | 0;
                        remaining_1_mut = remove(next, remaining_1);
                        placed_mut = cons(next, placed);
                        continue place;
                    }
                    break;
                }
            };
            return map((index) => item(index, lines).Lid, place(ofList_1(segL, {
                Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
            }), empty()));
        }
    }
}

/**
 * When given a segment index search for nearby segments to be considered with it as a single cluster
 * for spreading out. To be included segments must be close enough and overlapping. Search
 * terminates given large gap or a fixed boundary segments are not allowed to move across.
 */
export function expandCluster(index, searchDir, lines) {
    const nextIndex = (i) => {
        if (searchDir.tag === 0) {
            return (i + 1) | 0;
        }
        else {
            return (i - 1) | 0;
        }
    };
    const searchStart = item(index, lines).P;
    let patternInput;
    if (searchDir.tag === 1) {
        const loc = searchDir.fields[0];
        patternInput = [new Cluster(loc.UpperFix, loc.LowerFix, singleton(max(loc.Segments, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })), loc.Bound), min(loc.Segments, {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        })];
    }
    else {
        patternInput = [new Cluster(undefined, undefined, singleton(index), item(index, lines).B), undefined];
    }
    const expand = (i_1_mut, loc_1_mut) => {
        expand:
        while (true) {
            const i_1 = i_1_mut, loc_1 = loc_1_mut;
            const nSegs = length_1(loc_1.Segments);
            if (((i_1 < 0) ? true : (i_1 >= lines.length)) ? true : (Math.abs(item(i_1, lines).P - searchStart) > ((Constants_maxSegmentSeparation * (nSegs + 2)) + Constants_smallOffset))) {
                return new Cluster(loc_1.UpperFix, loc_1.LowerFix, sortDescending(loc_1.Segments, {
                    Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                }), loc_1.Bound);
            }
            else if (!hasOverlap(loc_1.Bound, item(i_1, lines).B)) {
                i_1_mut = nextIndex(i_1);
                loc_1_mut = loc_1;
                continue expand;
            }
            else {
                item(i_1, lines).P;
                const matchValue = item(i_1, lines).LType;
                switch (matchValue) {
                    case "lINKEDSEG": {
                        i_1_mut = nextIndex(i_1);
                        loc_1_mut = loc_1;
                        continue expand;
                    }
                    case "nORMSEG": {
                        i_1_mut = nextIndex(i_1);
                        loc_1_mut = (new Cluster(loc_1.UpperFix, loc_1.LowerFix, cons(i_1, loc_1.Segments), boundUnion(loc_1.Bound, item(i_1, lines).B)));
                        continue expand;
                    }
                    default: {
                        const p_1 = item(i_1, lines).P;
                        const loc_2 = (searchDir.tag === 0) ? (new Cluster(p_1, loc_1.LowerFix, loc_1.Segments, loc_1.Bound)) : (new Cluster(loc_1.UpperFix, p_1, loc_1.Segments, loc_1.Bound));
                        return new Cluster(loc_2.UpperFix, loc_2.LowerFix, sortDescending(loc_2.Segments, {
                            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
                        }), loc_2.Bound);
                    }
                }
            }
            break;
        }
    };
    return expand(nextIndex(index), patternInput[0]);
}

/**
 * Check a cluster for same net segments within separateCaptureOverlap
 * Remove from cluster and all except one in every such same net group
 * The removed segments are marked LINKEDSEG and linked for later processing
 */
export function linkAndRemoveSameNetSegments(lines, cluster) {
    return new Cluster(cluster.UpperFix, cluster.LowerFix, map((line_1) => (LineId__get_Index(line_1.Lid) | 0), filter((line) => (line.LType !== "lINKEDSEG"), linkSameNetLines(Constants_separateCaptureOverlap, map((seg) => item(seg, lines), cluster.Segments)))), cluster.Bound);
}

/**
 * Report the rare case of a segment getting "orphaned" - left out of every cluster.
 * This should probably never happen, and should be fixed if it is ever seen.
 * 
 * Once per key, not once per occurrence: this is reached from the separation scan, which runs on
 * every symbol move, so an unconditional complaint here would arrive at drag rate.
 */
export function warnLostSegmentInCluster(msg, lines, lostIndex, loc) {
    warnOnce(msg, `${msg} (segment index ${lostIndex}, cluster of ${length_1(loc.Segments)})`);
}

/**
 * Scan through segments in P order creating a list of local Clusters.
 * Within one cluster segments are adjacent and overlapping. Note that
 * different clusters may occupy the same P values if their segments do
 * not overlap.
 * Segments within each cluster will be repositioned and reordered after
 * clusters are identified.
 * Every segment must be part of a unique cluster.
 */
export function makeClusters(lines) {
    const groupableA = initialize(lines.length, (i) => (item(i, lines).LType === "nORMSEG"));
    const groupable = (seg) => item(seg, groupableA);
    const getClusters = (lines_1) => {
        let loc1LostSegs, loc_3;
        const matchValue = tryFindIndex((y) => (true === y), groupableA);
        if (matchValue != null) {
            const nextIndex = matchValue | 0;
            const handleLostNextIndex = (msg, loc_2) => {
                if (!contains(nextIndex, loc_2.Segments, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: (x_1) => (numberHash(x_1) | 0),
                })) {
                    warnLostSegmentInCluster(msg, lines_1, nextIndex, loc_2);
                    return ofArray([new Cluster(undefined, undefined, singleton(nextIndex), loc_2.Bound), loc_2]);
                }
                else {
                    return singleton(loc_2);
                }
            };
            const loc1 = expandCluster(nextIndex, LocSearchDir.Upwards, lines_1);
            const loc2 = expandCluster(max(loc1.Segments, {
                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
            }), new LocSearchDir(/* Downwards */ 1, [loc1]), lines_1);
            const newLocs = filter((loc_4) => !equals(loc_4.Segments, empty()), map((loc) => (new Cluster(loc.UpperFix, loc.LowerFix, filter(groupable, loc.Segments), loc.Bound)), !isEmpty_1(loc2.Segments) ? ((item(head(loc2.Segments), lines_1).P > item(nextIndex, lines_1).P) ? ((loc1LostSegs = List_except(loc2.Segments, loc1.Segments, {
                Equals: (x_3, y_3) => (x_3 === y_3),
                GetHashCode: (x_3) => (numberHash(x_3) | 0),
            }), equals(loc1LostSegs, empty()) ? singleton(loc2) : ((!contains(nextIndex, loc1LostSegs, {
                Equals: (x_4, y_4) => (x_4 === y_4),
                GetHashCode: (x_4) => (numberHash(x_4) | 0),
            }) ? warnOnce("cluster-lost-segment", "a segment was lost from a wire cluster during separation, and was repaired") : undefined, append(singleton(loc2), handleLostNextIndex("What? nextIndex has got lost from loc1 after expansion!", (loc_3 = (new Cluster(loc2.LowerFix, loc1.LowerFix, loc1LostSegs, reduce(boundUnion, map((i_1) => item(i_1, lines_1).B, loc1LostSegs)))), expandCluster(max(loc_3.Segments, {
                Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
            }), new LocSearchDir(/* Downwards */ 1, [loc_3]), lines_1)))))))) : (!contains(nextIndex, loc2.Segments, {
                Equals: (x_6, y_6) => (x_6 === y_6),
                GetHashCode: (x_6) => (numberHash(x_6) | 0),
            }) ? handleLostNextIndex("What? nextIndex has got lost from loc2!", loc2) : singleton(loc2))) : (!contains(nextIndex, loc2.Segments, {
                Equals: (x_6, y_6) => (x_6 === y_6),
                GetHashCode: (x_6) => (numberHash(x_6) | 0),
            }) ? handleLostNextIndex("What? nextIndex has got lost from loc2!", loc2) : singleton(loc2))));
            iterate((loc_1) => {
                iterate((seg_1) => {
                    setItem(groupableA, seg_1, false);
                }, loc_1.Segments);
            }, newLocs);
            if (groupable(nextIndex)) {
                toFail(printf("Error: infinite loop detected in cluster find code"));
            }
            return append(newLocs, getClusters(lines_1));
        }
        else {
            return empty();
        }
    };
    return map((cluster) => linkAndRemoveSameNetSegments(lines, cluster), getClusters(lines));
}

/**
 * Function which given a cluster (loc) works out how to
 * spread out the contained segments optimally, spacing them from other segments and symbols.
 * Return value is a list of segments, represented as Lines, paired with where they move.
 * lines is the source list of lines (vertical or horizontal according to which is being processed).
 * model is the Buswire model needed to access wires.
 */
export function calcSegPositions(model, lines, loc) {
    const segs = orderPairwiseToMinimiseCrossings(model, lines, List_distinct(loc.Segments, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (numberHash(x) | 0),
    }));
    const pts = map((i) => item(i, lines).P, segs);
    const nSeg = length_1(loc.Segments) | 0;
    const spreadFromMiddle = (mid, sep_1) => {
        iterateIndexed((i_2, seg_1) => {
            item(seg_1, lines).P = ((mid + (sep_1 * i_2)) - (((nSeg - 1) * sep_1) / 2));
        }, segs);
    };
    const halfMaxSep = Constants_maxSegmentSeparation / 2;
    const idealMidpoint = (min(pts, {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }) + max(pts, {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    })) / 2;
    const halfIdealWidth = (nSeg - 1) * halfMaxSep;
    const idealStart = idealMidpoint - halfIdealWidth;
    const idealEnd = idealMidpoint + halfIdealWidth;
    const matchValue_2 = loc.UpperFix;
    const matchValue_3 = loc.LowerFix;
    let matchResult, bMax_3, bMin_3, n_3, bMin_4, bMax_4, n_4, bMax_5, bMin_5, n_5;
    if (matchValue_2 != null) {
        if (matchValue_3 != null) {
            if (((matchValue_2 - matchValue_3) / (nSeg + 1)) < Constants_maxSegmentSeparation) {
                matchResult = 1;
                bMax_3 = matchValue_2;
                bMin_3 = matchValue_3;
                n_3 = nSeg;
            }
            else if ((matchValue_3 + Constants_maxSegmentSeparation) > idealStart) {
                matchResult = 2;
                bMin_4 = matchValue_3;
            }
            else if ((matchValue_2 - Constants_maxSegmentSeparation) < idealEnd) {
                matchResult = 3;
                bMax_4 = matchValue_2;
                n_4 = nSeg;
            }
            else {
                matchResult = 4;
                bMax_5 = matchValue_2;
                bMin_5 = matchValue_3;
                n_5 = nSeg;
            }
        }
        else if ((matchValue_2 - Constants_maxSegmentSeparation) < idealEnd) {
            matchResult = 3;
            bMax_4 = matchValue_2;
            n_4 = nSeg;
        }
        else {
            matchResult = 4;
            bMax_5 = matchValue_2;
            bMin_5 = matchValue_3;
            n_5 = nSeg;
        }
    }
    else if (matchValue_3 != null) {
        if ((matchValue_3 + Constants_maxSegmentSeparation) > idealStart) {
            matchResult = 2;
            bMin_4 = matchValue_3;
        }
        else {
            matchResult = 4;
            bMax_5 = matchValue_2;
            bMin_5 = matchValue_3;
            n_5 = nSeg;
        }
    }
    else if (nSeg === 1) {
        matchResult = 0;
    }
    else {
        matchResult = 4;
        bMax_5 = matchValue_2;
        bMin_5 = matchValue_3;
        n_5 = nSeg;
    }
    switch (matchResult) {
        case 0: {
            break;
        }
        case 1: {
            spreadFromMiddle((bMax_3 + bMin_3) / 2, (bMax_3 - bMin_3) / (n_3 + 1));
            break;
        }
        case 2: {
            const start = bMin_4 + Constants_maxSegmentSeparation;
            iterateIndexed((i_1, seg) => {
                item(seg, lines).P = (start + (Constants_maxSegmentSeparation * i_1));
            }, segs);
            break;
        }
        case 3: {
            const endP = bMax_4 - Constants_maxSegmentSeparation;
            iterateIndexed((i_3, seg_2) => {
                item(seg_2, lines).P = (endP + (Constants_maxSegmentSeparation * (i_3 - (nSeg - 1))));
            }, segs);
            break;
        }
        case 4: {
            spreadFromMiddle(idealMidpoint, Constants_maxSegmentSeparation);
            break;
        }
    }
}

/**
 * Given a list of segment changes of given orientation apply them to the model.
 * Also returns whether any segment actually moved: a settling round which moved nothing needs no
 * further examination, and that is the common case after a drag.
 */
export function adjustSegmentsInModel(ori, model, lines) {
    const positionNow = (line) => {
        const matchValue = line.Seg1;
        if (matchValue != null) {
            const seg = matchValue;
            if (ori === "vertical") {
                return seg.Start.X;
            }
            else {
                return seg.Start.Y;
            }
        }
        else {
            return line.P;
        }
    };
    const boxes = map((tupledArg_1) => {
        let sym_2, patternInput, sym_3, comp, matchValue_1, vS, hS, matchValue_2, left, right;
        return [tupledArg_1[0], (sym_2 = tupledArg_1[1], (patternInput = ((sym_3 = sym_2, (comp = sym_3.Component, (matchValue_1 = defaultArg(sym_3.HScale, 1), (vS = defaultArg(sym_3.VScale, 1), (hS = matchValue_1, (matchValue_2 = sym_3.STransform.Rotation, (matchValue_2.tag === 2) ? [comp.H * vS, comp.W * hS] : ((matchValue_2.tag === 1) ? [comp.W * hS, comp.H * vS] : ((matchValue_2.tag === 3) ? [comp.W * hS, comp.H * vS] : [comp.H * vS, comp.W * hS]))))))))), equals(sym_2.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton) ? (new BoundingBox((left = sym_2.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17)) : (new BoundingBox(sym_2.Pos, patternInput[1], patternInput[0]))))];
    }, filter((tupledArg) => equals(tupledArg[1].Annotation, undefined), toList_1(model.Symbol.Symbols)));
    const insideABoxAt = (line_2, p) => {
        let patternInput_2;
        const line_1 = line_2;
        const matchValue_3 = line_1.Seg1;
        if (matchValue_3 != null) {
            const seg_1 = matchValue_3;
            patternInput_2 = ((ori === "vertical") ? [min_1(seg_1.Start.Y, seg_1.End.Y), max_1(seg_1.Start.Y, seg_1.End.Y)] : [min_1(seg_1.Start.X, seg_1.End.X), max_1(seg_1.Start.X, seg_1.End.X)]);
        }
        else {
            patternInput_2 = [line_1.B.MinB, line_1.B.MaxB];
        }
        return exists((tupledArg_2) => {
            const b = tupledArg_2[1];
            const patternInput_3 = (ori === "vertical") ? [b.TopLeft.X, b.TopLeft.X + b.W, b.TopLeft.Y, b.TopLeft.Y + b.H] : [b.TopLeft.Y, b.TopLeft.Y + b.H, b.TopLeft.X, b.TopLeft.X + b.W];
            if ((((patternInput_3[0] + 0.5) < p) && (p < (patternInput_3[1] - 0.5))) && (patternInput_2[0] < (patternInput_3[3] - 0.5))) {
                return (patternInput_3[2] + 0.5) < patternInput_2[1];
            }
            else {
                return false;
            }
        }, boxes);
    };
    const newlyEntersABox = (line_3, p_1) => {
        if (insideABoxAt(line_3, p_1)) {
            return !insideABoxAt(line_3, positionNow(line_3));
        }
        else {
            return false;
        }
    };
    iterate((line_4) => {
        const matchValue_4 = line_4.LType;
        switch (matchValue_4) {
            case "bARRIERPOS":
            case "bARRIERNEG":
            case "lINKEDSEG": {
                break;
            }
            default:
                if ((Math.abs(line_4.P - positionNow(line_4)) > 1E-07) && (newlyEntersABox(line_4, line_4.P) ? true : exists((f) => newlyEntersABox(f, line_4.P), line_4.SameNetLink))) {
                    line_4.P = positionNow(line_4);
                }
        }
    }, lines);
    iterate((line_5) => {
        iterate((line2) => {
            line2.P = line_5.P;
        }, line_5.SameNetLink);
    }, lines);
    const patternInput_4 = fold_1((tupledArg_3, line_7) => [moveLine(ori, line_7.P, line_7, tupledArg_3[0]), tupledArg_3[1] ? true : (line_7.P !== positionNow(line_7))], [model.Wires, false], filter((line_6) => {
        if (line_6.LType !== "bARRIERPOS") {
            return line_6.LType !== "bARRIERNEG";
        }
        else {
            return false;
        }
    }, lines));
    return [patternInput_4[1], Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_BusWireT_wires_)(patternInput_4[0])(model)];
}

/**
 * Segments which could be moved, but would make an extra segment if moved, are marked Fixed
 * and not moved by the normal cluster-based separation functions.
 * This function looks at these segments and moves them a little in the special case that they
 * overlap. It is called after the main segment separation is complete.
 */
export function separateFixedSegments(wiresToRoute, ori, model) {
    const spaceOnSide = (lines, line, excludeLine, maxOffset, dir) => {
        const p = line.P;
        const _arg = tryFindIndexInArray(LineId__get_Index(line.Lid) + dir, dir, (line2) => ((hasOverlap(line2.B, line.B) && !equals(line2.Lid, excludeLine.Lid)) && (Math.abs(line2.P - p) > Constants_overlapTolerance)), (l1) => (Math.abs(l1.P - p) > (2 * maxOffset)), lines);
        if (_arg != null) {
            const a = _arg;
            return Math.abs(item(LineId__get_Index(a), lines).P - p);
        }
        else {
            return maxOffset;
        }
    };
    const allLines = makeLines(wiresToRoute, ori, model);
    const checkedLines = allLines.filter((line_1) => (line_1.LType === "fIXEDSEG"));
    iterate_1((line1) => {
        iterate_1((line2_2) => {
            const maxOffset_1 = 2 * Constants_maxSegmentSeparation;
            const gap = Math.abs(line1.P - line2_2.P);
            const needed = Constants_minWireSeparation - gap;
            const dir1 = ((gap > 0.001) ? sign(line1.P - line2_2.P) : ((spaceOnSide(allLines, line1, line2_2, maxOffset_1, 1) > spaceOnSide(allLines, line1, line2_2, maxOffset_1, -1)) ? 1 : -1)) | 0;
            const avail1 = max_1(0, spaceOnSide(allLines, line1, line2_2, maxOffset_1, dir1) - Constants_minWireSeparation);
            const avail2 = max_1(0, spaceOnSide(allLines, line2_2, line1, maxOffset_1, op_UnaryNegation_Int32(dir1)) - Constants_minWireSeparation);
            const move2 = min_1(needed - min_1(needed / 2, avail1), avail2);
            const move1 = min_1(needed - move2, avail1);
            if ((move1 + move2) < (needed - 0.5)) {
                warnOnce("no-space-for-overlap", "no space to shift fixed segments apart to minimum separation");
            }
            line1.P = (line1.P + (dir1 * move1));
            line2_2.P = (line2_2.P - (dir1 * move2));
        }, filter_1((line2_1) => {
            if (((compare(line1.Lid, line2_1.Lid) < 0) && (Math.abs(line1.P - line2_1.P) < Constants_minWireSeparation)) && !equals(line1.PortId, line2_1.PortId)) {
                return hasOverlap(line1.B, line2_1.B);
            }
            else {
                return false;
            }
        }, checkedLines));
    }, checkedLines);
    return adjustSegmentsInModel(ori, model, ofArray(allLines))[1];
}

/**
 * Return the index of the Line with the smallest value of P > p
 * Use binary earch for speed.
 * 
 * The search narrows towards `lines[below].P < p <= lines[above].P`, so the bottom end has to be
 * checked before it starts: with below = 0 taken on trust, an array whose first line is already
 * at or above p returns 1 and the caller never looks at line 0.
 * If every line is below p the last index is returned, which callers detect for themselves.
 */
export function findInterval(lines, p) {
    const find = (above_mut, below_mut) => {
        find:
        while (true) {
            const above = above_mut, below = below_mut;
            if ((above - below) < 2) {
                return above | 0;
            }
            else {
                const mid = ~~((above + below) / 2) | 0;
                if (item(mid, lines).P < p) {
                    above_mut = above;
                    below_mut = mid;
                    continue find;
                }
                else {
                    above_mut = mid;
                    below_mut = below;
                    continue find;
                }
            }
            break;
        }
    };
    if ((lines.length === 0) ? true : (item(0, lines).P >= p)) {
        return 0;
    }
    else {
        return find(lines.length - 1, 0) | 0;
    }
}

/**
 * Return true if there is no overlap between line and lines array (with exception of excludedLine).
 * All lines are the same type (parallel)
 */
export function checkExtensionNoOverlap(overlap, ext, excludedWire, info) {
    const lines = (ext.ExtOri === "vertical") ? info.VLines : info.HLines;
    const p = ext.ExtP;
    const check = (i_mut) => {
        check:
        while (true) {
            const i = i_mut;
            if (((i >= lines.length) ? true : (i < 0)) ? true : (item(i, lines).P > (p + overlap))) {
                return true;
            }
            else if (equals(item(i, lines).Wid, excludedWire) ? true : !hasNearOverlap(overlap, ext.ExtB, item(i, lines).B)) {
                i_mut = (i + 1);
                continue check;
            }
            else {
                return false;
            }
            break;
        }
    };
    return check(findInterval(lines, p - overlap));
}

/**
 * Return true if the extension crosses nothing it should not: no symbol boundary, and no segment
 * of another net.
 * 
 * The other-net half is what stops corner removal undoing separation. A corner is removed by
 * extending a segment to where the removed pair used to reach, which can be a long way - on
 * 3cpu/datapath it was 47 units - and the segment lands wherever the corner happened to be
 * rather than where separation put it. Separation has already ordered that cluster to minimise
 * crossings; a removal which crosses another net is undoing that work for the sake of two fewer
 * bends, and the bends are the cheaper thing.
 * 
 * Same-net crossings are not refused: one signal crossing itself misleads nobody, and a net
 * which fans out will do it. `lines` are of the opposite orientation to the extension, so a
 * crossing is one of them spanning the extension's P while the extension spans its own.
 */
export function checkExtensionNoCrossings(overlap, ext, excludedWire, info) {
    const lines = (ext.ExtOri === "vertical") ? info.HLines : info.VLines;
    const b = ext.ExtB;
    const p = ext.ExtP;
    let ownNet;
    const option_1 = tryFind(excludedWire, info.WireMap);
    ownNet = ((option_1 != null) ? option_1.OutputPort : undefined);
    const check = (i_mut) => {
        check:
        while (true) {
            const i = i_mut;
            if ((i >= lines.length) ? true : (i < 0)) {
                return true;
            }
            else {
                const otherLine = item(i, lines);
                if (otherLine.P > (b.MaxB + overlap)) {
                    return true;
                }
                else {
                    const otherB = otherLine.B;
                    let crossed;
                    const matchValue_1 = otherLine.LType;
                    switch (matchValue_1) {
                        case "bARRIERPOS":
                        case "bARRIERNEG": {
                            crossed = true;
                            break;
                        }
                        default:
                            crossed = !equals(otherLine.PortId, ownNet);
                    }
                    if (((equals(otherLine.Wid, excludedWire) ? true : (otherB.MinB > p)) ? true : (otherB.MaxB < p)) ? true : !crossed) {
                        i_mut = (i + 1);
                        continue check;
                    }
                    else {
                        return false;
                    }
                }
            }
            break;
        }
    };
    return check(findInterval(lines, b.MinB - overlap));
}

/**
 * Process the symbols and wires in Model generating arrays of Horizontal and Vertical lines.
 * In addition the inverse map is generated which can map each segmnet to the corresponding Line if that
 * exists.
 * Note that Lines reference segments, which contain wire Id and segment Index and can therefore be used to
 * reference the corresponding wire via the model.Wires map.
 */
export function makeLineInfo(wiresToRoute, model) {
    const hLines = makeLines(wiresToRoute, "horizontal", model);
    const vLines = makeLines(wiresToRoute, "vertical", model);
    return new LineInfo(vLines, hLines, model.Wires, ofArray_1(collect_1((line) => {
        let this$;
        const matchValue = line.Seg1;
        if (matchValue != null) {
            return [[(this$ = matchValue.Segment, [this$.Index, this$.WireId]), line.Lid]];
        }
        else {
            return [];
        }
    }, append_1(hLines, vLines)), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }));
}

/**
 * Return true if the given segment length change is allowed.
 * If the new segment creates a part line segment
 * that did not previouly exist this is checked for overlap
 * with symbols and other wires.
 * startShift is how far the start of the segment itself moves along its own axis: zero when the
 * segment keeps its start point, negative when it is extended backwards (as the second segment of
 * a removed corner is, since the segment before it has gone).
 */
export function isSegmentExtensionOk(info, wire, segNum, ori, startShift, newLength) {
    let this$, this$_1;
    const segs = wire.Segments;
    const seg = item_1(segNum, wire.Segments);
    const aSegStart = getAbsoluteSegmentPos(wire, segNum)[0];
    const patternInput_1 = (ori === "horizontal") ? [aSegStart.Y, aSegStart.X] : [aSegStart.X, aSegStart.Y];
    const newStartC = patternInput_1[1] + startShift;
    const extension = new Extension(ori, new Bound_2(min_1(newStartC, newStartC + newLength), max_1(newStartC, newStartC + newLength)), patternInput_1[0]);
    if ((((segNum === 2) && ((this$ = item_1(1, segs), Math.abs(this$.Length) < 1E-07))) && (sign(item_1(0, segs).Length) !== sign(newLength))) ? true : (((segNum === (length_1(segs) - 3)) && ((this$_1 = item_1(length_1(segs) - 2, segs), Math.abs(this$_1.Length) < 1E-07))) && (sign(item_1(length_1(segs) - 1, segs).Length) !== sign(newLength)))) {
        return false;
    }
    else if ((segNum === 0) && (sign(seg.Length) !== sign(newLength))) {
        return false;
    }
    else if (checkExtensionNoOverlap(Constants_extensionTolerance, extension, wire.WId, info)) {
        return checkExtensionNoCrossings(Constants_extensionTolerance, extension, wire.WId, info);
    }
    else {
        return false;
    }
}

/**
 * Return the list of wire corners found in given wire with all corner
 * edges smaller than cornerSizeLimit. A wire can have at most one corner.
 */
export function findWireCorner(info, cornerSizeLimit, wire) {
    const segs = wire.Segments;
    const _arg = tryPick((start) => {
        let this$, this$_1;
        const seg = item_1(start, segs);
        if (((this$ = item_1(start, segs), Math.abs(this$.Length) < 1E-07)) ? true : ((this$_1 = item_1(start + 3, segs), Math.abs(this$_1.Length) < 1E-07))) {
            return undefined;
        }
        else {
            const matchValue = item_1(start + 1, segs);
            const deletedSeg2 = item_1(start + 2, segs);
            const deletedSeg1 = matchValue;
            const hasManualSegment = exists((i) => (item_1(i, segs).Mode === "manual"), toList(rangeDouble(start, 1, start + 3)));
            const hasLongSegment = max_1(Math.abs(deletedSeg1.Length), Math.abs(deletedSeg2.Length)) > cornerSizeLimit;
            if (((hasManualSegment ? true : hasLongSegment) ? true : (Math.abs(deletedSeg1.Length) < 1E-07)) ? true : (Math.abs(deletedSeg2.Length) < 1E-07)) {
                return undefined;
            }
            else {
                const ori = wire.InitialOrientation;
                const startSegOrientation = ((seg.Index % 2) === 0) ? ori : ((ori === "vertical") ? "horizontal" : "vertical");
                const newLength1 = seg.Length + deletedSeg2.Length;
                const newLength2 = item_1(start + 3, segs).Length + deletedSeg1.Length;
                const endSegStartShift = -deletedSeg1.Length;
                if (isSegmentExtensionOk(info, wire, start, startSegOrientation, 0, newLength1) && isSegmentExtensionOk(info, wire, start + 3, (startSegOrientation === "vertical") ? "horizontal" : "vertical", endSegStartShift, newLength2)) {
                    return new WireCorner(wire, start, deletedSeg2.Length, deletedSeg1.Length, startSegOrientation);
                }
                else {
                    return undefined;
                }
            }
        }
    }, toList(rangeDouble(0, 1, length_1(wire.Segments) - 5)));
    if (_arg != null) {
        return singleton(_arg);
    }
    else {
        return empty();
    }
}

/**
 * Change LineInfo removing a corner from a wire.
 * TODO: currently only WireMap changes
 */
export function removeCorner(info, wc) {
    let start, source_2;
    const addLengthToSegment = (delta, seg_1) => (new DrawModelType_BusWireT_Segment(seg_1.Index, seg_1.Length + delta, seg_1.WireId, seg_1.IntersectOrJumpList, seg_1.Draggable, seg_1.Mode));
    let wire$0027;
    const bind$0040 = wc.Wire;
    wire$0027 = (new DrawModelType_BusWireT_Wire(bind$0040.WId, bind$0040.InputPort, bind$0040.OutputPort, bind$0040.Color, bind$0040.Width, (start = ((wc.StartSeg + 1) | 0), mapIndexed((i, seg) => {
        if (i > (start - 1)) {
            return new DrawModelType_BusWireT_Segment(i, seg.Length, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode);
        }
        else {
            return seg;
        }
    }, removeManyAt(start, 2, (source_2 = updateAt(wc.StartSeg, addLengthToSegment(wc.StartSegChange, item_1(wc.StartSeg, wc.Wire.Segments)), wc.Wire.Segments), updateAt(wc.StartSeg + 3, addLengthToSegment(wc.EndSegChange, item_1(wc.StartSeg + 3, wc.Wire.Segments)), source_2))))), bind$0040.StartPos, bind$0040.InitialOrientation));
    return new LineInfo(info.VLines, info.HLines, add(wire$0027.WId, wire$0027, info.WireMap), info.LineMap);
}

/**
 * Return model with corners identified and removed where possible.
 * Corners are artifacts - usually small - which give wires more visible segments than is needed.
 */
export function removeModelCorners(wires, model) {
    const info = makeLineInfo(wires, model);
    const info$0027 = fold_1(removeCorner, info, collect((wire) => findWireCorner(info, Constants_maxCornerSize, wire), MapModule_ValuesL(model.Wires)));
    return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_BusWireT_wires_)(info$0027.WireMap)(model);
}

/**
 * Return None, or Some wire' where wire' is wire with spikes removed.
 * Spikes segments that turn back on previous ones (with a zero-length segment in between).
 * Optimised for the case that there are no spikes and None is returned.
 */
export function removeWireSpikes(wire) {
    const removeFrom = (n_mut, removedAny_mut, segs_mut) => {
        removeFrom:
        while (true) {
            const n = n_mut, removedAny = removedAny_mut, segs = segs_mut;
            let this$;
            const nSeg = length_1(segs) | 0;
            if (n > (nSeg - 3)) {
                if (removedAny) {
                    return segs;
                }
                else {
                    return undefined;
                }
            }
            else if (!((this$ = item_1(n + 1, segs), Math.abs(this$.Length) < 1E-07)) ? true : (sign(item_1(n, segs).Length) === sign(item_1(n + 2, segs).Length))) {
                n_mut = (n + 1);
                removedAny_mut = removedAny;
                segs_mut = segs;
                continue removeFrom;
            }
            else {
                let newSegN;
                const bind$0040 = item_1(n, segs);
                newSegN = (new DrawModelType_BusWireT_Segment(bind$0040.Index, item_1(n, segs).Length + item_1(n + 2, segs).Length, bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode));
                const lastSegs = getSlice(n + 3, nSeg - 1, segs);
                n_mut = n;
                removedAny_mut = true;
                segs_mut = concat([getSlice(0, n - 1, segs), singleton(newSegN), mapIndexed((i, seg) => (new DrawModelType_BusWireT_Segment((i + n) + 1, seg.Length, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode)), lastSegs)]);
                continue removeFrom;
            }
            break;
        }
    };
    const option_1 = removeFrom(0, false, wire.Segments);
    if (option_1 != null) {
        return new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, option_1, wire.StartPos, wire.InitialOrientation);
    }
    else {
        return undefined;
    }
}

/**
 * return model with all wire spikes removed
 */
export function removeModelSpikes(model) {
    return new DrawModelType_BusWireT_Model(model.Symbol, fold((wires, wid, wire) => {
        const matchValue = removeWireSpikes(wire);
        if (matchValue != null) {
            return add(wid, matchValue, wires);
        }
        else {
            return wires;
        }
    }, model.Wires, model.Wires), model.CopiedWires, model.SelectedSegment, model.LastMousePos, model.ErrorWires, model.Notifications, model.Type, model.ArrowDisplay, model.SnapToNet);
}

class DrawnSeg extends Record {
    constructor(Ori, P, Lo, Hi, Net) {
        super();
        this.Ori = (Ori | 0);
        this.P = P;
        this.Lo = Lo;
        this.Hi = Hi;
        this.Net = Net;
    }
}

function DrawnSeg_$reflection() {
    return record_type("BusWireSeparate.DrawnSeg", [], DrawnSeg, () => [["Ori", int32_type], ["P", float64_type], ["Lo", float64_type], ["Hi", float64_type], ["Net", int32_type]]);
}

class CostSweep extends Record {
    constructor(Drawn, Covered, Line, AllNets, ByNet) {
        super();
        this.Drawn = Drawn;
        this.Covered = Covered;
        this.Line = Line;
        this.AllNets = AllNets;
        this.ByNet = ByNet;
    }
}

function CostSweep_$reflection() {
    return record_type("BusWireSeparate.CostSweep", [], CostSweep, () => [["Drawn", float64_type], ["Covered", float64_type], ["Line", option_type(tuple_type(int32_type, float64_type))], ["AllNets", option_type(tuple_type(float64_type, float64_type))], ["ByNet", list_type(tuple_type(int32_type, float64_type, float64_type))]]);
}

/**
 * Symbol clearance missing from a sheet: for every segment separation is able to move, and every
 * symbol that segment runs alongside, how far short of clearanceFromSymbol it stands.
 * 
 * This is the half of separation's objective that length cannot express. Spreading segments and
 * standing them clear of symbols both make the drawing LONGER, so a cost function counting only
 * wire would refuse every separation which had no overlap to pay for it - and did, leaving wires
 * hugging the symbols they arrive at on any sheet whose nets do not cross.
 * 
 * A segment is charged for the WORST symbol it runs beside, not the sum over all of them, and not
 * scaled by how much of it runs alongside. What a reader notices is that a wire is touching a
 * symbol; neither how long the touch is nor how many symbols it repeats against changes the
 * answer to "should this segment move". Summing over symbols instead makes the term grow with
 * symbol density, so on a dense sheet clearance outranks everything else the cost measures - and
 * it duly did: summing cost reg16x8 nine crossings and 600 units of wire after a drag, and
 * pushed wrappedArrays onto the worse of its two phases. Taking the worst symbol leaves every
 * corpus sheet exactly where it was.
 * 
 * The two symbols a wire connects to are NOT exempt, unlike in adjustSegmentsInModel. A wire must
 * be allowed to touch its own symbol, but that is what the nub is for, and the nub - with the
 * zero-length segment beside it and everything else separation cannot move - is excluded here
 * anyway. The riser that arrives at a port hugging that symbol's edge is exactly what this is
 * meant to see. Where a wire legitimately runs INSIDE its own symbol's box (a mux SEL port sits
 * in from the trapezoid edge) the full clearance is charged and no round can remove it, which
 * costs nothing: the acceptance rule compares two layouts of one sheet, and a charge present in
 * both cancels.
 */
export function clearanceCost(model) {
    const boxes = toArray(map((sym_1) => {
        let left, right;
        const sym_2 = sym_1;
        let patternInput;
        const sym_3 = sym_2;
        const comp = sym_3.Component;
        const matchValue = defaultArg(sym_3.HScale, 1);
        const vS = defaultArg(sym_3.VScale, 1);
        const hS = matchValue;
        const matchValue_2 = sym_3.STransform.Rotation;
        switch (matchValue_2.tag) {
            case 1:
            case 3: {
                patternInput = [comp.W * hS, comp.H * vS];
                break;
            }
            default:
                patternInput = [comp.H * vS, comp.W * hS];
        }
        return equals(sym_2.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton) ? (new BoundingBox((left = sym_2.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17)) : (new BoundingBox(sym_2.Pos, patternInput[1], patternInput[0]));
    }, filter((sym) => equals(sym.Annotation, undefined), MapModule_ValuesL(model.Symbol.Symbols))));
    return sumBy((wire_3) => {
        let wire, numSegs, vec, left_1, right_1, this$, wire_2;
        return sumBy((aSeg_1) => fold_3((worst, b) => {
            let aSeg, box, patternInput_2, matchValue_3, this$_1, delta, left_2, right_2, p;
            return max_1(worst, (aSeg = aSeg_1, (box = b, (patternInput_2 = ((matchValue_3 = ((this$_1 = aSeg, (delta = ((left_2 = this$_1.Start, (right_2 = this$_1.End, new XYPos(left_2.X - right_2.X, left_2.Y - right_2.Y)))), (Math.abs(delta.X) > Math.abs(delta.Y)) ? "horizontal" : "vertical"))), (matchValue_3 === "vertical") ? [aSeg.Start.X, min_1(aSeg.Start.Y, aSeg.End.Y), max_1(aSeg.Start.Y, aSeg.End.Y), box.TopLeft.X, box.TopLeft.X + box.W, box.TopLeft.Y, box.TopLeft.Y + box.H] : [aSeg.Start.Y, min_1(aSeg.Start.X, aSeg.End.X), max_1(aSeg.Start.X, aSeg.End.X), box.TopLeft.Y, box.TopLeft.Y + box.H, box.TopLeft.X, box.TopLeft.X + box.W])), (p = patternInput_2[0], ((patternInput_2[2] <= patternInput_2[5]) ? true : (patternInput_2[6] <= patternInput_2[1])) ? 0 : (Constants_clearanceFromSymbol - min_1(max_1(0, max_1(patternInput_2[3] - p, p - patternInput_2[4])), Constants_clearanceFromSymbol)))))));
        }, 0, boxes), (wire = wire_3, (numSegs = (length_1(wire.Segments) | 0), (((vec = ((left_1 = wire.StartPos, (right_1 = ((this$ = wire, (wire_2 = this$, fold_1((tupledArg, seg) => {
            const currOrientation = tupledArg[2];
            let nextPos;
            const position = tupledArg[1];
            const length = seg.Length;
            nextPos = ((currOrientation === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)));
            return [nextPos, nextPos, (currOrientation === "vertical") ? "horizontal" : "vertical"];
        }, [this$.StartPos, wire_2.StartPos, wire_2.InitialOrientation], wire_2.Segments)[0]))), new XYPos(left_1.X - right_1.X, left_1.Y - right_1.Y)))), Math.sqrt(Math.pow(vec.X, 2) + Math.pow(vec.Y, 2)))) <= Constants_minWireLengthToSeparate) ? empty() : getFilteredAbsSegments((_arg_3, seg_1) => (((seg_1.Index !== 0) && (seg_1.Index !== (numSegs - 1))) && (Math.abs(seg_1.Length) > Constants_minVisibleSegmentLength)), wire))), {
            GetZero: () => 0,
            Add: (x, y) => (x + y),
        });
    }, MapModule_ValuesL(model.Wires), {
        GetZero: () => 0,
        Add: (x_1, y_1) => (x_1 + y_1),
    });
}

/**
 * How bad a wiring is, in three terms: the length of wire actually drawn, a heavy penalty for two
 * different nets drawn on top of each other, and what clearance the wires are short of.
 * 
 * Wire drawn is the length of the UNION of the segments on each line of the drawing, so two
 * segments of one net lying on top of each other are one wire and are counted once. That makes
 * "keep wires short" and "let a net share a trunk" the same objective rather than two which have
 * to be traded off by hand.
 * 
 * The clearance term is what makes this a score for SEPARATION rather than for routing. The other
 * two are both minimised by the drawing separation starts from: spreading segments apart and
 * standing them clear of symbols costs wire and removes no overlap, so a length-only cost refuses
 * every round of it that has nothing else to show, and a sheet whose nets never cross was left
 * exactly as routing drew it - wires hugging the symbols they arrive at. A cost function used to
 * accept or reject a pass has to measure what that pass is for.
 * 
 * This is called once per settling round: one sort and one sweep for the first two terms, one
 * pass over segments against symbol boxes for the third. Deliberately not built on makeLines,
 * which links same-net lines pairwise and costs as much as a separation pass.
 */
export function wiringCost(model) {
    const drawn = collect_1((tupledArg) => {
        const wire = tupledArg[1];
        return toArray(map((aSeg) => {
            let matchValue;
            const this$_1 = aSeg;
            let delta;
            const left = this$_1.Start;
            const right = this$_1.End;
            delta = (new XYPos(left.X - right.X, left.Y - right.Y));
            matchValue = ((Math.abs(delta.X) > Math.abs(delta.Y)) ? "horizontal" : "vertical");
            if (matchValue === "vertical") {
                return new DrawnSeg(1, aSeg.Start.X, min_1(aSeg.Start.Y, aSeg.End.Y), max_1(aSeg.Start.Y, aSeg.End.Y), wire.OutputPort);
            }
            else {
                return new DrawnSeg(0, aSeg.Start.Y, min_1(aSeg.Start.X, aSeg.End.X), max_1(aSeg.Start.X, aSeg.End.X), wire.OutputPort);
            }
        }, getFilteredAbsSegments((_arg_1, seg) => !(Math.abs(seg.Length) < 1E-07), wire)));
    }, toArray_1(model.Wires));
    sortInPlaceBy((s) => [s.Ori, s.P, s.Lo], drawn, {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    });
    const flush = (state) => {
        let matchValue_1;
        return new CostSweep(state.Drawn + sumBy((tupledArg_1) => (tupledArg_1[2] - tupledArg_1[1]), state.ByNet, {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        }), state.Covered + ((matchValue_1 = state.AllNets, (matchValue_1 == null) ? 0 : (matchValue_1[1] - matchValue_1[0]))), undefined, undefined, empty());
    };
    const swept = flush(fold_3((state_1, seg_1) => {
        let p, hi_3, lo_3, hi_4, lo_4, hi_6, lo_6, run_1, hi_7, lo_7, run_2;
        let state_2;
        const matchValue_2 = state_1.Line;
        let matchResult, ori_1, p_1;
        if (matchValue_2 != null) {
            if ((p = matchValue_2[1], (matchValue_2[0] === seg_1.Ori) && (Math.abs(seg_1.P - p) < Constants_overlapTolerance))) {
                matchResult = 0;
                ori_1 = matchValue_2[0];
                p_1 = matchValue_2[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                state_2 = state_1;
                break;
            }
            default: {
                const bind$0040 = flush(state_1);
                state_2 = (new CostSweep(bind$0040.Drawn, bind$0040.Covered, [seg_1.Ori, seg_1.P], bind$0040.AllNets, bind$0040.ByNet));
            }
        }
        let patternInput;
        const matchValue_3 = state_2.AllNets;
        patternInput = ((matchValue_3 == null) ? [[seg_1.Lo, seg_1.Hi], 0] : (((matchValue_3[0], seg_1.Lo <= matchValue_3[1])) ? ((hi_3 = matchValue_3[1], (lo_3 = matchValue_3[0], [[lo_3, max_1(hi_3, seg_1.Hi)], 0]))) : ((hi_4 = matchValue_3[1], (lo_4 = matchValue_3[0], [[seg_1.Lo, seg_1.Hi], hi_4 - lo_4])))));
        let patternInput_1;
        const matchValue_4 = tryFind_1((tupledArg_2) => equals(tupledArg_2[0], seg_1.Net), state_2.ByNet);
        patternInput_1 = ((matchValue_4 == null) ? [cons([seg_1.Net, seg_1.Lo, seg_1.Hi], state_2.ByNet), 0] : (((matchValue_4[1], seg_1.Lo <= matchValue_4[2])) ? ((hi_6 = matchValue_4[2], (lo_6 = matchValue_4[1], (run_1 = matchValue_4, [cons([seg_1.Net, lo_6, max_1(hi_6, seg_1.Hi)], List_except([run_1], state_2.ByNet, {
            Equals: equalArrays,
            GetHashCode: (x_2) => (arrayHash(x_2) | 0),
        })), 0])))) : ((hi_7 = matchValue_4[2], (lo_7 = matchValue_4[1], (run_2 = matchValue_4, [cons([seg_1.Net, seg_1.Lo, seg_1.Hi], List_except([run_2], state_2.ByNet, {
            Equals: equalArrays,
            GetHashCode: (x_3) => (arrayHash(x_3) | 0),
        })), hi_7 - lo_7]))))));
        return new CostSweep(state_2.Drawn + patternInput_1[1], state_2.Covered + patternInput[1], state_2.Line, patternInput[0], patternInput_1[0]);
    }, new CostSweep(0, 0, undefined, undefined, empty()), drawn));
    return (swept.Drawn + (Constants_overlapCostWeight * (swept.Drawn - swept.Covered))) + (Constants_clearanceCostWeight * clearanceCost(model));
}

/**
 * Perform complete segment ordering and separation for segments of given orientation.
 * wiresToRoute: the clusters worked on are those holding at least one of these wires. Lines are
 * generated for ALL wires either way - a cluster is defined by everything near it - and passing
 * every wire id makes this a whole-sheet pass.
 */
export function separateModelSegmentsOneOrientation(wiresToRoute, ori, model) {
    let list_1, routable, routedLines;
    const lines_1 = makeLines(MapModule_KeysL(model.Wires), ori, model);
    iterate((loc) => {
        calcSegPositions(model, lines_1, loc);
    }, (list_1 = makeClusters(lines_1), (routable = ofList_1(wiresToRoute, {
        Compare: (x, y) => (compare(x, y) | 0),
    }), (routedLines = lines_1.filter((line) => FSharpSet__Contains(routable, line.Wid)), filter((cluster) => exists((seg) => routedLines.some((line_1) => (LineId__get_Index(line_1.Lid) === seg)), cluster.Segments), list_1)))));
    return adjustSegmentsInModel(ori, model, ofArray(lines_1));
}

/**
 * Where two wires of a net run along a shared trunk and turn off it at different points, move one
 * turn onto the other so the net leaves the trunk once, as a T junction. The reader sees one
 * branch instead of two near-parallel ones, and the drawing is strictly shorter - the move is
 * only made when it is.
 * 
 * The candidate moved is a wire's interior perpendicular segment (the "riser"): its base slides
 * along the trunk to the other riser's position, its two neighbours stretching and shrinking to
 * pay for it, exactly as a segment drag would. Guards, in order:
 * - the riser is not a segment the user dragged, and its neighbours are interior and keep their
 * directions (a neighbour driven past zero would fold the wire back over itself). A wire with
 * hand-routed segments is an ordinary member of its net here: what it may not do is move the
 * segments that were pinned;
 * - the riser at its new position stays at least minWireSeparation clear of every
 * same-orientation segment of any OTHER net it would run beside - the one thing separation
 * cannot repair afterwards, since no later pass runs;
 * - it also stays clear of every symbol: the merged riser can reach further along its axis than
 * the riser it joins, into space nothing has checked.
 * Of the two ways round (move A to B, move B to A) the one leaving less visible wire wins, and a
 * move is only made when the net's drawn length strictly falls - which is also what guarantees
 * the repeated scan terminates.
 */
export function alignSameNetDepartures(wiresToRoute, model) {
    const netDrawnLength = (wires) => sumBy((tupledArg_1) => sumBy((tupledArg_4) => {
        let list_7;
        return ((list_7 = sortBy_1((tuple) => tuple[0], tupledArg_4[1], {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }), fold_1((tupledArg_5, tupledArg_6) => {
            const upTo = tupledArg_5[1];
            const hi_1 = tupledArg_6[1];
            return [tupledArg_5[0] + max_1(0, hi_1 - max_1(tupledArg_6[0], upTo)), max_1(upTo, hi_1)];
        }, [0, -Number.POSITIVE_INFINITY], list_7)))[0];
    }, fold_1((lines, tupledArg_3) => {
        const p_1 = tupledArg_3[1];
        const lo = tupledArg_3[2];
        const hi = tupledArg_3[3];
        let matchResult, lastP_1, rest_1, spans_1;
        if (!isEmpty_1(lines)) {
            if (Math.abs(p_1 - head(lines)[0]) < 1) {
                matchResult = 0;
                lastP_1 = head(lines)[0];
                rest_1 = tail(lines);
                spans_1 = head(lines)[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return cons([lastP_1, cons([lo, hi], spans_1)], rest_1);
            default:
                return cons([p_1, singleton([lo, hi])], lines);
        }
    }, empty(), sortBy_1((tupledArg_2) => tupledArg_2[1], tupledArg_1[1], {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    })), {
        GetZero: () => 0,
        Add: (x_3, y_3) => (x_3 + y_3),
    }), List_groupBy((tupledArg) => tupledArg[0], collect((w) => map((s_1) => {
        let matchValue;
        const this$_1 = s_1;
        let delta;
        const left = this$_1.Start;
        const right = this$_1.End;
        delta = (new XYPos(left.X - right.X, left.Y - right.Y));
        matchValue = ((Math.abs(delta.X) > Math.abs(delta.Y)) ? "horizontal" : "vertical");
        if (matchValue === "vertical") {
            return ["vertical", s_1.Start.X, min_1(s_1.Start.Y, s_1.End.Y), max_1(s_1.Start.Y, s_1.End.Y)];
        }
        else {
            return ["horizontal", s_1.Start.Y, min_1(s_1.Start.X, s_1.End.X), max_1(s_1.Start.X, s_1.End.X)];
        }
    }, filter((s) => !(Math.abs(s.Segment.Length) < 1E-07), getAbsSegments(w))), wires), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), {
        GetZero: () => 0,
        Add: (x_4, y_4) => (x_4 + y_4),
    });
    const symbolBoxes = map((sym) => {
        let left_1, right_1;
        const sym_1 = sym;
        let patternInput;
        const sym_2 = sym_1;
        const comp = sym_2.Component;
        const matchValue_1 = defaultArg(sym_2.HScale, 1);
        const vS = defaultArg(sym_2.VScale, 1);
        const hS = matchValue_1;
        const matchValue_2 = sym_2.STransform.Rotation;
        switch (matchValue_2.tag) {
            case 1:
            case 3: {
                patternInput = [comp.W * hS, comp.H * vS];
                break;
            }
            default:
                patternInput = [comp.H * vS, comp.W * hS];
        }
        return equals(sym_1.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton) ? (new BoundingBox((left_1 = sym_1.Pos, (right_1 = (new XYPos(9, 9)), new XYPos(left_1.X - right_1.X, left_1.Y - right_1.Y))), 17, 17)) : (new BoundingBox(sym_1.Pos, patternInput[1], patternInput[0]));
    }, filter((s_2) => equals(s_2.Annotation, undefined), MapModule_ValuesL(model.Symbol.Symbols)));
    const departures = (wire) => {
        const aSegs = getAbsSegments(wire);
        const n = length_1(wire.Segments) | 0;
        return toList(delay(() => collect_2((i) => {
            const visible = (j) => (Math.abs(item_1(j, wire.Segments).Length) > Constants_minVisibleSegmentLength);
            return ((((item_1(i, wire.Segments).Mode !== "manual") && visible(i)) && visible(i - 1)) && visible(i + 1)) ? singleton_1([i, item_1(i, aSegs), item_1(i - 1, aSegs)]) : empty_1();
        }, rangeDouble(2, 1, n - 3))));
    };
    const wireCrossings = (wire_2) => {
        const mySegs = filter((s_3) => !(Math.abs(s_3.Segment.Length) < 1E-07), getAbsSegments(wire_2));
        return sumBy((tupledArg_7) => {
            const other = tupledArg_7[1];
            if (equals(other.OutputPort, wire_2.OutputPort)) {
                return 0;
            }
            else {
                return sumBy((s_4) => {
                    if (Math.abs(s_4.Segment.Length) < 1E-07) {
                        return 0;
                    }
                    else {
                        return sumBy((m) => {
                            let this$_4, delta_2, left_2, right_2, this$_5, delta_3, left_3, right_3, this$_6, delta_4, left_4, right_4;
                            if (((this$_4 = m, (delta_2 = ((left_2 = this$_4.Start, (right_2 = this$_4.End, new XYPos(left_2.X - right_2.X, left_2.Y - right_2.Y)))), (Math.abs(delta_2.X) > Math.abs(delta_2.Y)) ? "horizontal" : "vertical"))) === ((this$_5 = s_4, (delta_3 = ((left_3 = this$_5.Start, (right_3 = this$_5.End, new XYPos(left_3.X - right_3.X, left_3.Y - right_3.Y)))), (Math.abs(delta_3.X) > Math.abs(delta_3.Y)) ? "horizontal" : "vertical")))) {
                                return 0;
                            }
                            else {
                                const patternInput_2 = (((this$_6 = m, (delta_4 = ((left_4 = this$_6.Start, (right_4 = this$_6.End, new XYPos(left_4.X - right_4.X, left_4.Y - right_4.Y)))), (Math.abs(delta_4.X) > Math.abs(delta_4.Y)) ? "horizontal" : "vertical"))) === "horizontal") ? [m, s_4] : [s_4, m];
                                const v = patternInput_2[1];
                                const h_1 = patternInput_2[0];
                                const y_5 = h_1.Start.Y;
                                const x_5 = v.Start.X;
                                const matchValue_5 = min_1(h_1.Start.X, h_1.End.X);
                                const matchValue_6 = max_1(h_1.Start.X, h_1.End.X);
                                const matchValue_7 = min_1(v.Start.Y, v.End.Y);
                                const matchValue_8 = max_1(v.Start.Y, v.End.Y);
                                if (((((matchValue_5 + 0.01) < x_5) && (x_5 < (matchValue_6 - 0.01))) && ((matchValue_7 + 0.01) < y_5)) && (y_5 < (matchValue_8 - 0.01))) {
                                    return 1;
                                }
                                else {
                                    return 0;
                                }
                            }
                        }, mySegs, {
                            GetZero: () => 0,
                            Add: (x_6, y_6) => ((x_6 + y_6) | 0),
                        }) | 0;
                    }
                }, getAbsSegments(other), {
                    GetZero: () => 0,
                    Add: (x_7, y_7) => ((x_7 + y_7) | 0),
                }) | 0;
            }
        }, toList_1(model.Wires), {
            GetZero: () => 0,
            Add: (x_8, y_8) => ((x_8 + y_8) | 0),
        }) | 0;
    };
    const wireBoxCrossings = (wire_3) => {
        const exempt = ofArray([FSharpMap__get_Item(model.Symbol.Ports, wire_3.InputPort).HostId, FSharpMap__get_Item(model.Symbol.Ports, wire_3.OutputPort).HostId]);
        const boxed = map((tupledArg_9) => {
            let left_5, right_5;
            const sym_5 = tupledArg_9[1];
            let patternInput_6;
            const sym_6 = sym_5;
            const comp_1 = sym_6.Component;
            const matchValue_9 = defaultArg(sym_6.HScale, 1);
            const vS_1 = defaultArg(sym_6.VScale, 1);
            const hS_1 = matchValue_9;
            const matchValue_2_1 = sym_6.STransform.Rotation;
            switch (matchValue_2_1.tag) {
                case 1:
                case 3: {
                    patternInput_6 = [comp_1.W * hS_1, comp_1.H * vS_1];
                    break;
                }
                default:
                    patternInput_6 = [comp_1.H * vS_1, comp_1.W * hS_1];
            }
            if (equals(sym_5.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton)) {
                return new BoundingBox((left_5 = sym_5.Pos, (right_5 = (new XYPos(9, 9)), new XYPos(left_5.X - right_5.X, left_5.Y - right_5.Y))), 17, 17);
            }
            else {
                return new BoundingBox(sym_5.Pos, patternInput_6[1], patternInput_6[0]);
            }
        }, filter((tupledArg_8) => {
            if (equals(tupledArg_8[1].Annotation, undefined)) {
                return !contains(tupledArg_8[0], exempt, {
                    Equals: equals,
                    GetHashCode: (x_9) => (safeHash(x_9) | 0),
                });
            }
            else {
                return false;
            }
        }, toList_1(model.Symbol.Symbols)));
        return sumBy((sg) => {
            if (Math.abs(sg.Segment.Length) < 1E-07) {
                return 0;
            }
            else {
                const matchValue_10 = min_1(sg.Start.X, sg.End.X);
                const matchValue_11 = max_1(sg.Start.X, sg.End.X);
                const matchValue_12 = min_1(sg.Start.Y, sg.End.Y);
                const matchValue_13 = max_1(sg.Start.Y, sg.End.Y);
                return sumBy((b) => {
                    if (overlap1D(matchValue_10, matchValue_11, b.TopLeft.X + 0.5, (b.TopLeft.X + b.W) - 0.5) && overlap1D(matchValue_12, matchValue_13, b.TopLeft.Y + 0.5, (b.TopLeft.Y + b.H) - 0.5)) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                }, boxed, {
                    GetZero: () => 0,
                    Add: (x_10, y_10) => ((x_10 + y_10) | 0),
                }) | 0;
            }
        }, getAbsSegments(wire_3), {
            GetZero: () => 0,
            Add: (x_11, y_11) => ((x_11 + y_11) | 0),
        }) | 0;
    };
    const tryMove = (netWires, wire_4, i_2, targetP) => {
        let matchValue_14, this$_8, delta_5, left_6, right_6, patternInput_14, matchValue_20, this$_15, delta_12, left_12, right_12, trunkP, junctionAt, segsAll, trunkCovers, branchGoes;
        const riser = item_1(i_2, getAbsSegments(wire_4));
        let moved;
        const wire_1 = wire_4;
        const i_1 = i_2 | 0;
        const delta_1 = targetP - ((matchValue_14 = ((this$_8 = riser, (delta_5 = ((left_6 = this$_8.Start, (right_6 = this$_8.End, new XYPos(left_6.X - right_6.X, left_6.Y - right_6.Y)))), (Math.abs(delta_5.X) > Math.abs(delta_5.Y)) ? "horizontal" : "vertical"))), (matchValue_14 === "horizontal") ? riser.Start.Y : riser.Start.X));
        moved = (new DrawModelType_BusWireT_Wire(wire_1.WId, wire_1.InputPort, wire_1.OutputPort, wire_1.Color, wire_1.Width, mapIndexed((j_1, seg) => {
            if (j_1 === (i_1 - 1)) {
                return new DrawModelType_BusWireT_Segment(seg.Index, seg.Length + delta_1, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode);
            }
            else if (j_1 === (i_1 + 1)) {
                return new DrawModelType_BusWireT_Segment(seg.Index, seg.Length - delta_1, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode);
            }
            else {
                return seg;
            }
        }, wire_1.Segments), wire_1.StartPos, wire_1.InitialOrientation));
        if (!forAll((j_2) => {
            const matchValue_15 = item_1(j_2, wire_4.Segments).Length;
            const after = item_1(j_2, moved.Segments).Length;
            if (Math.abs(after) > 1E-07) {
                return sign(after) === sign(matchValue_15);
            }
            else {
                return false;
            }
        }, ofArray([i_2 - 1, i_2 + 1]))) {
            return undefined;
        }
        else {
            let patternInput_11;
            let matchValue_17;
            const this$_9 = riser;
            let delta_7;
            const left_7 = this$_9.Start;
            const right_7 = this$_9.End;
            delta_7 = (new XYPos(left_7.X - right_7.X, left_7.Y - right_7.Y));
            matchValue_17 = ((Math.abs(delta_7.X) > Math.abs(delta_7.Y)) ? "horizontal" : "vertical");
            patternInput_11 = ((matchValue_17 === "horizontal") ? [min_1(riser.Start.X, riser.End.X), max_1(riser.Start.X, riser.End.X)] : [min_1(riser.Start.Y, riser.End.Y), max_1(riser.Start.Y, riser.End.Y)]);
            const lo_2 = patternInput_11[0];
            const hi_2 = patternInput_11[1];
            const clearOfWires = forAll_1((_arg_13, other_1) => {
                if (equals(other_1.OutputPort, wire_4.OutputPort)) {
                    return true;
                }
                else {
                    return forAll((s_5) => {
                        let this$_11, delta_8, left_8, right_8, this$_12, delta_9, left_9, right_9;
                        if ((Math.abs(s_5.Segment.Length) < 1E-07) ? true : (((this$_11 = s_5, (delta_8 = ((left_8 = this$_11.Start, (right_8 = this$_11.End, new XYPos(left_8.X - right_8.X, left_8.Y - right_8.Y)))), (Math.abs(delta_8.X) > Math.abs(delta_8.Y)) ? "horizontal" : "vertical"))) !== ((this$_12 = riser, (delta_9 = ((left_9 = this$_12.Start, (right_9 = this$_12.End, new XYPos(left_9.X - right_9.X, left_9.Y - right_9.Y)))), (Math.abs(delta_9.X) > Math.abs(delta_9.Y)) ? "horizontal" : "vertical"))))) {
                            return true;
                        }
                        else {
                            let patternInput_12;
                            let matchValue_18;
                            const this$_13 = s_5;
                            let delta_10;
                            const left_10 = this$_13.Start;
                            const right_10 = this$_13.End;
                            delta_10 = (new XYPos(left_10.X - right_10.X, left_10.Y - right_10.Y));
                            matchValue_18 = ((Math.abs(delta_10.X) > Math.abs(delta_10.Y)) ? "horizontal" : "vertical");
                            patternInput_12 = ((matchValue_18 === "horizontal") ? [s_5.Start.Y, min_1(s_5.Start.X, s_5.End.X), max_1(s_5.Start.X, s_5.End.X)] : [s_5.Start.X, min_1(s_5.Start.Y, s_5.End.Y), max_1(s_5.Start.Y, s_5.End.Y)]);
                            if ((Math.abs(patternInput_12[0] - targetP) >= Constants_minWireSeparation) ? true : (patternInput_12[1] >= hi_2)) {
                                return true;
                            }
                            else {
                                return patternInput_12[2] <= lo_2;
                            }
                        }
                    }, getAbsSegments(other_1));
                }
            }, model.Wires);
            const clearOfSymbols = forAll((box) => {
                let patternInput_13;
                let matchValue_19;
                const this$_14 = riser;
                let delta_11;
                const left_11 = this$_14.Start;
                const right_11 = this$_14.End;
                delta_11 = (new XYPos(left_11.X - right_11.X, left_11.Y - right_11.Y));
                matchValue_19 = ((Math.abs(delta_11.X) > Math.abs(delta_11.Y)) ? "horizontal" : "vertical");
                patternInput_13 = ((matchValue_19 === "horizontal") ? [box.TopLeft.X, box.TopLeft.X + box.W, box.TopLeft.Y, box.TopLeft.Y + box.H] : [box.TopLeft.Y, box.TopLeft.Y + box.H, box.TopLeft.X, box.TopLeft.X + box.W]);
                if (((targetP <= (patternInput_13[2] - Constants_minWireSeparation)) ? true : (targetP >= (patternInput_13[3] + Constants_minWireSeparation))) ? true : (hi_2 <= (patternInput_13[0] - Constants_minWireSeparation))) {
                    return true;
                }
                else {
                    return lo_2 >= (patternInput_13[1] + Constants_minWireSeparation);
                }
            }, symbolBoxes);
            if (!(clearOfWires && clearOfSymbols)) {
                return undefined;
            }
            else if (wireCrossings(moved) > wireCrossings(wire_4)) {
                return undefined;
            }
            else if (wireBoxCrossings(moved) > wireBoxCrossings(wire_4)) {
                return undefined;
            }
            else {
                const others = filter((w_3) => !equals(w_3.WId, wire_4.WId), netWires);
                if (((patternInput_14 = ((matchValue_20 = ((this$_15 = riser, (delta_12 = ((left_12 = this$_15.Start, (right_12 = this$_15.End, new XYPos(left_12.X - right_12.X, left_12.Y - right_12.Y)))), (Math.abs(delta_12.X) > Math.abs(delta_12.Y)) ? "horizontal" : "vertical"))), (matchValue_20 === "horizontal") ? [riser.Start.X, targetP] : [riser.Start.Y, targetP])), (trunkP = patternInput_14[0], (junctionAt = patternInput_14[1], (segsAll = filter((sg_1) => (Math.abs(sg_1.Segment.Length) > Constants_minVisibleSegmentLength), collect(getAbsSegments, cons(moved, others))), (trunkCovers = ((offset) => exists((sg_2) => {
                    let this$_16, delta_13, left_13, right_13, this$_17, delta_14, left_14, right_14;
                    if (((this$_16 = sg_2, (delta_13 = ((left_13 = this$_16.Start, (right_13 = this$_16.End, new XYPos(left_13.X - right_13.X, left_13.Y - right_13.Y)))), (Math.abs(delta_13.X) > Math.abs(delta_13.Y)) ? "horizontal" : "vertical"))) !== ((this$_17 = riser, (delta_14 = ((left_14 = this$_17.Start, (right_14 = this$_17.End, new XYPos(left_14.X - right_14.X, left_14.Y - right_14.Y)))), (Math.abs(delta_14.X) > Math.abs(delta_14.Y)) ? "horizontal" : "vertical")))) {
                        let patternInput_15;
                        let matchValue_21;
                        const this$_18 = sg_2;
                        let delta_15;
                        const left_15 = this$_18.Start;
                        const right_15 = this$_18.End;
                        delta_15 = (new XYPos(left_15.X - right_15.X, left_15.Y - right_15.Y));
                        matchValue_21 = ((Math.abs(delta_15.X) > Math.abs(delta_15.Y)) ? "horizontal" : "vertical");
                        patternInput_15 = ((matchValue_21 === "vertical") ? [sg_2.Start.X, min_1(sg_2.Start.Y, sg_2.End.Y), max_1(sg_2.Start.Y, sg_2.End.Y)] : [sg_2.Start.Y, min_1(sg_2.Start.X, sg_2.End.X), max_1(sg_2.Start.X, sg_2.End.X)]);
                        if ((Math.abs(patternInput_15[0] - trunkP) < 1) && (patternInput_15[1] < (junctionAt + offset))) {
                            return (junctionAt + offset) < patternInput_15[2];
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }, segsAll)), (branchGoes = ((side) => exists((sg_3) => {
                    let this$_19, delta_16, left_16, right_16, this$_20, delta_17, left_17, right_17;
                    if (((this$_19 = sg_3, (delta_16 = ((left_16 = this$_19.Start, (right_16 = this$_19.End, new XYPos(left_16.X - right_16.X, left_16.Y - right_16.Y)))), (Math.abs(delta_16.X) > Math.abs(delta_16.Y)) ? "horizontal" : "vertical"))) === ((this$_20 = riser, (delta_17 = ((left_17 = this$_20.Start, (right_17 = this$_20.End, new XYPos(left_17.X - right_17.X, left_17.Y - right_17.Y)))), (Math.abs(delta_17.X) > Math.abs(delta_17.Y)) ? "horizontal" : "vertical")))) {
                        let patternInput_16;
                        let matchValue_22;
                        const this$_21 = sg_3;
                        let delta_18;
                        const left_18 = this$_21.Start;
                        const right_18 = this$_21.End;
                        delta_18 = (new XYPos(left_18.X - right_18.X, left_18.Y - right_18.Y));
                        matchValue_22 = ((Math.abs(delta_18.X) > Math.abs(delta_18.Y)) ? "horizontal" : "vertical");
                        patternInput_16 = ((matchValue_22 === "horizontal") ? [sg_3.Start.Y, min_1(sg_3.Start.X, sg_3.End.X), max_1(sg_3.Start.X, sg_3.End.X)] : [sg_3.Start.X, min_1(sg_3.Start.Y, sg_3.End.Y), max_1(sg_3.Start.Y, sg_3.End.Y)]);
                        const lo_4 = patternInput_16[1];
                        const hi_4 = patternInput_16[2];
                        if (((Math.abs(patternInput_16[0] - junctionAt) < 1) && ((lo_4 - 1) < trunkP)) && (trunkP < (hi_4 + 1))) {
                            if (side > 0) {
                                return hi_4 > (trunkP + 1);
                            }
                            else {
                                return lo_4 < (trunkP - 1);
                            }
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }, segsAll)), length_1(filter((x_12) => x_12, ofArray([trunkCovers(-1.5), trunkCovers(1.5), branchGoes(1), branchGoes(-1)])))))))))) >= 4) {
                    return undefined;
                }
                else {
                    return [netDrawnLength(cons(moved, others)), moved];
                }
            }
        }
    };
    let netsInScope;
    const routable = ofList_1(wiresToRoute, {
        Compare: (x_15, y_13) => (compare(x_15, y_13) | 0),
    });
    netsInScope = map((tuple_2) => tuple_2[0], filter((tupledArg_15) => {
        const ws = tupledArg_15[1];
        if (length_1(ws) > 1) {
            return exists((w_6) => FSharpSet__Contains(routable, w_6.WId), ws);
        }
        else {
            return false;
        }
    }, List_groupBy((w_5) => w_5.OutputPort, MapModule_ValuesL(model.Wires), {
        Equals: equals,
        GetHashCode: (x_16) => (safeHash(x_16) | 0),
    })));
    const settleJunctions = (model_2_mut, count_mut) => {
        settleJunctions:
        while (true) {
            const model_2 = model_2_mut, count = count_mut;
            if (count > 50) {
                return model_2;
            }
            else {
                const improved = tryPick((port) => {
                    const netWires_1 = filter((w_7) => equals(w_7.OutputPort, port), MapModule_ValuesL(model_2.Wires));
                    const current = netDrawnLength(netWires_1);
                    const _arg_17 = filter((tupledArg_13) => (tupledArg_13[0] < (current - 0.5)), collect((tupledArg_11) => {
                        const a_1 = tupledArg_11[0];
                        const b_2 = tupledArg_11[1];
                        return collect((tupledArg_12) => {
                            let this$_25, delta_22, left_22, right_22, this$_26, delta_23, left_23, right_23;
                            const _arg_14 = tupledArg_12[0];
                            const _arg_15 = tupledArg_12[1];
                            const rA = _arg_14[1];
                            const rB = _arg_15[1];
                            const pOf = (r) => {
                                let matchValue_23;
                                const this$_22 = r;
                                let delta_19;
                                const left_19 = this$_22.Start;
                                const right_19 = this$_22.End;
                                delta_19 = (new XYPos(left_19.X - right_19.X, left_19.Y - right_19.Y));
                                matchValue_23 = ((Math.abs(delta_19.X) > Math.abs(delta_19.Y)) ? "horizontal" : "vertical");
                                if (matchValue_23 === "horizontal") {
                                    return r.Start.Y;
                                }
                                else {
                                    return r.Start.X;
                                }
                            };
                            const baseOf = (r_1) => {
                                let matchValue_24;
                                const this$_23 = r_1;
                                let delta_20;
                                const left_20 = this$_23.Start;
                                const right_20 = this$_23.End;
                                delta_20 = (new XYPos(left_20.X - right_20.X, left_20.Y - right_20.Y));
                                matchValue_24 = ((Math.abs(delta_20.X) > Math.abs(delta_20.Y)) ? "horizontal" : "vertical");
                                if (matchValue_24 === "horizontal") {
                                    return r_1.Start.X;
                                }
                                else {
                                    return r_1.Start.Y;
                                }
                            };
                            const spanOf = (t) => {
                                let matchValue_25;
                                const this$_24 = t;
                                let delta_21;
                                const left_21 = this$_24.Start;
                                const right_21 = this$_24.End;
                                delta_21 = (new XYPos(left_21.X - right_21.X, left_21.Y - right_21.Y));
                                matchValue_25 = ((Math.abs(delta_21.X) > Math.abs(delta_21.Y)) ? "horizontal" : "vertical");
                                if (matchValue_25 === "vertical") {
                                    return [min_1(t.Start.Y, t.End.Y), max_1(t.Start.Y, t.End.Y)];
                                }
                                else {
                                    return [min_1(t.Start.X, t.End.X), max_1(t.Start.X, t.End.X)];
                                }
                            };
                            let trunksShared;
                            const matchValue_26 = spanOf(_arg_14[2]);
                            const matchValue_27 = spanOf(_arg_15[2]);
                            trunksShared = ((matchValue_26[0] <= (matchValue_27[1] + 0.1)) && (matchValue_27[0] <= (matchValue_26[1] + 0.1)));
                            if ((((((this$_25 = rA, (delta_22 = ((left_22 = this$_25.Start, (right_22 = this$_25.End, new XYPos(left_22.X - right_22.X, left_22.Y - right_22.Y)))), (Math.abs(delta_22.X) > Math.abs(delta_22.Y)) ? "horizontal" : "vertical"))) !== ((this$_26 = rB, (delta_23 = ((left_23 = this$_26.Start, (right_23 = this$_26.End, new XYPos(left_23.X - right_23.X, left_23.Y - right_23.Y)))), (Math.abs(delta_23.X) > Math.abs(delta_23.Y)) ? "horizontal" : "vertical")))) ? true : (Math.abs(baseOf(rA) - baseOf(rB)) > 1)) ? true : (Math.abs(pOf(rA) - pOf(rB)) < 1)) ? true : !trunksShared) {
                                return empty();
                            }
                            else {
                                return choose((x_13) => x_13, ofArray([tryMove(netWires_1, a_1, _arg_14[0], pOf(rB)), tryMove(netWires_1, b_2, _arg_15[0], pOf(rA))]));
                            }
                        }, allPairs(departures(a_1), departures(b_2)));
                    }, filter((tupledArg_10) => (connToInt(tupledArg_10[0].WId) < connToInt(tupledArg_10[1].WId)), allPairs(netWires_1, netWires_1))));
                    if (isEmpty_1(_arg_17)) {
                        return undefined;
                    }
                    else {
                        const best = minBy((tupledArg_14) => [tupledArg_14[0], connToInt(tupledArg_14[1].WId)], _arg_17, {
                            Compare: (x_14, y_12) => (compareArrays(x_14, y_12) | 0),
                        })[1];
                        return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_BusWireT_wireOf_(best.WId))(best)(model_2);
                    }
                }, netsInScope);
                if (improved == null) {
                    return model_2;
                }
                else {
                    model_2_mut = improved;
                    count_mut = (count + 1);
                    continue settleJunctions;
                }
            }
            break;
        }
    };
    return settleJunctions(model, 0);
}

/**
 * Perform complete wire segment separation and ordering for all orientations.
 * 
 * `wiresToRoute` is the SCOPE: only clusters holding one of these wires are touched, so a small
 * list is a local adjustment and every wire id is a whole-sheet pass. Which to use follows from
 * what changed. Adding one wire, or dragging a segment of one, disturbs only the clusters that
 * wire runs through - the rest of the sheet was settled a moment ago and owes nothing to this
 * change. Moving a SYMBOL is different: its wires may leave clusters anywhere on the sheet, and
 * the space they vacate is space other wires should take up, so a drag's mouse-up passes every
 * wire (see the MovingSymbols cases in SheetUpdateHelpers, and routeAndSeparateSymbolWires).
 * An empty list means nothing changed, and the whole pass is skipped.
 */
export function separateAndOrderModelSegments(wiresToRoute, model) {
    if (equals(wiresToRoute, empty())) {
        return model;
    }
    else {
        const separate = (ori, model_1) => separateModelSegmentsOneOrientation(wiresToRoute, ori, model_1);
        const settle = (roundsLeft_mut, best_mut, bestCost_mut, model_2_mut) => {
            settle:
            while (true) {
                const roundsLeft = roundsLeft_mut, best = best_mut, bestCost = bestCost_mut, model_2 = model_2_mut;
                if (roundsLeft <= 0) {
                    return best;
                }
                else {
                    const patternInput = separate("horizontal", model_2);
                    const patternInput_1 = separate("vertical", patternInput[1]);
                    const next = patternInput_1[1];
                    if (!(patternInput[0] ? true : patternInput_1[0])) {
                        return next;
                    }
                    else {
                        const cost = wiringCost(next);
                        if (cost < (bestCost - Constants_settlingTolerance)) {
                            roundsLeft_mut = (roundsLeft - 1);
                            best_mut = next;
                            bestCost_mut = cost;
                            model_2_mut = next;
                            continue settle;
                        }
                        else {
                            return best;
                        }
                    }
                }
                break;
            }
        };
        const wireShapes = (m) => map((tupledArg) => [tupledArg[0], map((sg) => sg.Length, tupledArg[1].Segments)], toList_1(m.Wires));
        const toFixpoint = (n_mut, model_7_mut) => {
            toFixpoint:
            while (true) {
                const n = n_mut, model_7 = model_7_mut;
                let separated;
                const model_3 = model_7;
                separated = removeModelCorners(wiresToRoute, separateFixedSegments(wiresToRoute, "vertical", separateFixedSegments(wiresToRoute, "horizontal", settle(Constants_maxSettlingRounds, model_3, wiringCost(model_3), model_3))));
                const aligned = alignSameNetDepartures(wiresToRoute, separated);
                if ((n <= 0) ? true : equals(wireShapes(aligned), wireShapes(separated))) {
                    return aligned;
                }
                else {
                    n_mut = (n - 1);
                    model_7_mut = aligned;
                    continue toFixpoint;
                }
                break;
            }
        };
        return toFixpoint(3, model);
    }
}

/**
 * Top-level function to replace updateWireSegmentJumps
 * and call the Segment separate code as well. This should
 * run when significant circuit wiring changes have been made
 * e.g. at the end of symbol drags.
 */
export function updateWireSegmentJumpsAndSeparations(wires, model) {
    return updateWireSegmentJumps(empty(), separateAndOrderModelSegments(wires, model));
}

/**
 * Take the routing off the wires `toRedraw` selects, route them all again from nothing, and then
 * separate the whole sheet as usual. Neither pass is changed: this is the ordinary pair of them,
 * applied to many wires at once instead of to the few a drag reaches. That is what makes it worth
 * having - a sheet laid out before a routing change keeps most of its old routing, and so says
 * almost nothing about whether the change helped.
 * 
 * The routing comes off every one of them BEFORE any of them is routed. Routing looks only at
 * symbols today, so that makes no difference yet; it will as soon as a wire is routed with any
 * regard for the wires already there, since a route which is about to be thrown away is not
 * something the next wire should be following.
 * 
 * Wires are reset rather than deleted and recreated: a wire is identified by the two ports it
 * joins, so deleting one would only lose its ConnectionId, which the saved file, undo and the
 * current selection all refer to.
 * 
 * They are routed shortest first, by the straight-line distance between the two ports. Order is
 * immaterial while routing considers only symbols, and this is the order to have when it stops
 * being: a short wire has the least freedom in where it can go, so it is the one that should
 * already be there when a longer wire of the same net is routed and looking for something to
 * join. The re-route this replaces went in Map order - by ConnectionId, which is a GUID, so in no
 * order at all and not the same one twice.
 */
export function redrawWires(toRedraw, model) {
    const toRoute = map((wire_1) => wire_1.WId, sortBy_1((wire) => {
        let portId_1, portId_5;
        let patternInput;
        const model_1 = model.Symbol;
        patternInput = [getPortLocation(undefined, model_1, (portId_1 = (new DrawModelType_SymbolT_DirectedPortId(/* InputId */ 0, [wire.InputPort])), (portId_1.tag === 1) ? portId_1.fields[0] : portId_1.fields[0])), getPortLocation(undefined, model_1, (portId_5 = (new DrawModelType_SymbolT_DirectedPortId(/* OutputId */ 1, [wire.OutputPort])), (portId_5.tag === 1) ? portId_5.fields[0] : portId_5.fields[0]))];
        let vec;
        const left = patternInput[1];
        const right = patternInput[0];
        vec = (new XYPos(left.X - right.X, left.Y - right.Y));
        return Math.sqrt(Math.pow(vec.X, 2) + Math.pow(vec.Y, 2));
    }, filter(toRedraw, MapModule_ValuesL(model.Wires)), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
    const model_6 = fold_1((model_5, wid_1) => {
        let optic_1, value_1;
        return ((optic_1 = DrawModelType_BusWireT_wireOf_(wid_1), (value_1 = smartAutoroute(model_5, FSharpMap__get_Item(model_5.Wires, wid_1)), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic_1)(value_1))))(model_5);
    }, fold_1((model_4, wid) => {
        let l;
        return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, (l = DrawModelType_BusWireT_wireOf_(wid), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_segments_)(l)))(empty())(model_4);
    }, model, toRoute), toRoute);
    return updateWireSegmentJumpsAndSeparations(MapModule_KeysL(model_6.Wires), model_6);
}

/**
 * Redraw every wire the user has not routed by hand, leaving those alone.
 */
export function redrawFloatingWires(model) {
    return redrawWires((arg) => !isManuallyRouted(arg), model);
}

/**
 * Separate the sheet with the hand-routed segments freed, then pin them again where they end up.
 * 
 * **Nothing here is re-routed.** Separation moves a segment along its own axis and no further, so
 * a wire that was dragged into a particular shape keeps that shape; what changes is which of the
 * parallel tracks each of its segments sits on. That is the thing hand routing cannot do for
 * itself - the user can put a wire where they want it, but not line it up with the ten other
 * wires that run beside it, because those move afterwards and it does not.
 * 
 * It is a menu item rather than part of the ordinary pass because it is a judgement the user has
 * to make. A pinned segment is pinned precisely because separation would otherwise have put it
 * somewhere else, so doing this on every edit would quietly undo hand routing a little at a time.
 * Asked for once, it does what the user means: "these are in the right place, now tidy them in
 * with the rest".
 * 
 * The pins are restored by segment index, and only where the wire still has the same number of
 * segments - corner and spike removal inside the separation pass can shorten a wire's list, and a
 * pin put back at an index that now means a different segment would be worse than no pin at all.
 */
export function separateManualRouting(model) {
    let model_1;
    const pinned = map_1((_arg, wire) => [length_1(wire.Segments), map((seg_1) => (seg_1.Index | 0), filter((seg) => (seg.Mode === "manual"), wire.Segments))], model.Wires);
    const setModes = (f, m) => (new DrawModelType_BusWireT_Model(m.Symbol, map_1((wid, wire_1) => Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_BusWireT_segments_)((list_2) => map((seg_2) => (new DrawModelType_BusWireT_Segment(seg_2.Index, seg_2.Length, seg_2.WireId, seg_2.IntersectOrJumpList, seg_2.Draggable, f(wid)(wire_1)(seg_2))), list_2))(wire_1), m.Wires), m.CopiedWires, m.SelectedSegment, m.LastMousePos, m.ErrorWires, m.Notifications, m.Type, m.ArrowDisplay, m.SnapToNet));
    return setModes((wid_1) => ((wire_2) => ((seg_3) => {
        let idxs;
        const matchValue = tryFind(wid_1, pinned);
        let matchResult, idxs_1, len_1;
        if (matchValue != null) {
            if ((idxs = matchValue[1], (matchValue[0] === length_1(wire_2.Segments)) && contains(seg_3.Index, idxs, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (numberHash(x) | 0),
            }))) {
                matchResult = 0;
                idxs_1 = matchValue[1];
                len_1 = matchValue[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return "manual";
            default:
                return "auto";
        }
    })), (model_1 = setModes((_arg_1) => ((_arg_2) => ((_arg_3) => "auto")), model), updateWireSegmentJumpsAndSeparations(MapModule_KeysL(model.Wires), model_1)));
}

/**
 * Redraw every wire, hand routing included.
 */
export function redrawAllWires(model) {
    return redrawWires((_arg) => true, model);
}

/**
 * Route and then separate after one symbol has changed - moved a step, rotated, scaled, flipped
 * or had its type edited. Uses partial routing to keep the symbol's hand-routed wires attached -
 * a changed port position must reach them, and the redraw below deliberately leaves manual wires
 * alone. A wire with both ends on the symbol is re-routed from each end in turn rather than
 * translated, since the symbol may have been resized or rotated, not just moved.
 * 
 * It ends as a drag does: every floating wire re-routed from scratch and the whole sheet
 * separated. A wire that had been ROUTED AROUND this symbol is not connected to it, so no
 * re-route of the symbol's own wires reaches it, and its detour is routing's - separation cannot
 * undo it. The layout left behind is exactly what "redraw floating wires" would produce, so a
 * symbol change leaves nothing for a redraw to improve.
 */
export function routeAndSeparateSymbolWires(model, compId) {
    const wires = filterWiresByCompMoved(model, singleton(compId));
    dbg(4, `routing and separating symbol wires: ${length_1(wires.Inputs)} inputs,                        ${length_1(wires.Outputs)} outputs, ${length_1(wires.Both)} both`);
    return redrawFloatingWires(rerouteMovedWires((model_1, wire) => updateWire(model_1, updateWire(model_1, wire, true), false), singleton(compId), model));
}

